var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _path67, _path68, _path69, _path70, _path71, _path72, _path73, _path74, _path75, _path76, _path77, _path78, _path79, _path80, _path81, _path82, _path83, _path84, _path85, _path86, _path87, _path88, _path89, _path90, _path91, _path92, _path93, _path94, _path95, _path96, _path97, _path98, _path99, _path100, _path101, _path102, _path103, _path104, _path105, _path106, _path107, _path108, _path109, _path110, _path111, _path112, _path113, _path114, _path115, _path116, _path117, _path118, _path119, _path120, _path121, _path122, _path123, _path124, _path125, _path126, _path127, _path128, _path129, _path130, _path131, _path132, _path133, _path134, _path135, _path136, _path137, _path138, _path139, _path140, _path141, _path142, _path143, _path144, _path145, _path146, _path147, _path148, _path149, _path150, _path151, _path152, _path153, _path154, _path155, _path156, _path157, _path158, _path159, _path160, _path161, _path162, _path163, _path164, _path165, _path166, _path167, _path168, _path169, _path170, _path171, _path172, _path173, _path174, _path175, _path176, _path177, _path178, _path179, _path180, _path181, _path182, _path183, _path184, _path185, _path186, _path187, _path188, _path189, _path190, _path191, _path192, _path193, _path194, _path195, _path196, _path197, _path198, _path199, _path200, _path201, _path202, _path203, _path204, _path205, _path206, _path207, _path208, _path209, _path210, _path211, _path212, _path213, _path214, _path215, _path216, _path217, _path218, _path219, _path220, _path221, _path222, _path223, _path224, _path225, _path226, _path227, _path228, _path229, _path230, _path231, _path232, _path233, _path234, _path235, _path236, _path237, _path238, _path239, _path240, _path241, _path242, _path243, _path244, _path245, _path246, _path247, _path248, _path249, _path250, _path251, _path252, _path253, _path254, _path255, _path256, _path257, _path258, _path259, _path260, _path261, _path262, _path263, _path264, _path265, _path266, _path267, _path268, _path269, _path270, _path271, _path272, _path273, _path274, _path275, _path276, _path277, _path278, _path279, _path280, _path281, _path282, _path283, _path284, _path285, _path286, _path287, _path288, _path289, _path290, _path291, _path292, _path293, _path294, _path295, _path296, _path297, _path298, _path299, _path300, _path301, _path302, _path303, _path304, _path305, _path306, _path307, _path308, _path309, _path310, _path311, _path312, _path313, _path314, _path315, _path316, _path317, _path318, _path319, _path320, _path321, _path322, _path323, _path324, _path325, _path326, _path327, _path328, _path329, _path330, _path331, _path332, _path333, _path334, _path335, _path336, _path337, _path338, _path339, _path340, _path341, _path342, _path343, _path344, _path345, _path346, _path347, _path348, _path349, _path350, _path351, _path352, _path353, _path354, _path355, _path356, _path357, _path358, _path359, _path360, _path361, _path362, _path363, _path364, _path365, _path366, _path367, _path368, _path369, _path370, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCoinsDrop(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 289,
    height: 331,
    viewBox: "0 0 289 331",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_13193_55427)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_13193_55427",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 35,
    y: 67,
    width: 61,
    height: 34
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M95.2767 94.5087C97.4972 91.2889 86.5702 83.0009 70.8875 75.9948C55.2048 68.9887 40.6879 65.9105 38.4673 69.1304C37.9399 69.8906 36.034 72.6707 35.5066 73.4309C33.286 76.6507 44.213 84.9388 59.8957 91.9448C75.5785 98.9509 90.0954 102.029 92.3159 98.8093C92.8433 98.0491 94.7493 95.269 95.2767 94.5087Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_13193_55427)"
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M95.2767 94.5087C97.4973 91.2889 86.5703 83.0009 70.8876 75.9948C55.2049 68.9887 40.6879 65.9105 38.4674 69.1304C37.94 69.8906 36.034 72.6707 35.5066 73.4309C33.2861 76.6507 44.2131 84.9388 59.8958 91.9448C75.5785 98.9509 90.0954 102.029 92.316 98.8093C92.8434 98.0491 94.7493 95.269 95.2767 94.5087Z",
    fill: "url(#paint0_linear_13193_55427)"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.68
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M40.514 67.6133L33.0452 78.4585L33.4255 78.6284L40.8943 67.7833L40.514 67.6133Z",
    fill: "#C38B2C"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M41.356 68.1426L33.8896 78.9888L34.2699 79.1587L41.7363 68.3125L41.356 68.1426Z",
    fill: "#C38B2C"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M42.2183 68.6724L34.7518 79.5186L35.1321 79.6884L42.5986 68.8422L42.2183 68.6724Z",
    fill: "#C38B2C"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M43.0736 69.1962L35.6095 80.0435L35.9898 80.2133L43.4539 69.366L43.0736 69.1962Z",
    fill: "#C38B2C"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M43.9689 69.7393L36.5024 80.5854L36.8827 80.7553L44.3492 69.9091L43.9689 69.7393Z",
    fill: "#C38B2C"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M44.8801 70.2778L37.4136 81.124L37.7939 81.2939L45.2604 70.4477L44.8801 70.2778Z",
    fill: "#C38B2C"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M45.7973 70.8131L38.3285 81.6582L38.7088 81.8281L46.1775 70.983L45.7973 70.8131Z",
    fill: "#C38B2C"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M46.7242 71.3608L39.2578 82.207L39.6381 82.3769L47.1045 71.5307L46.7242 71.3608Z",
    fill: "#C38B2C"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M47.6662 71.8999L40.1998 82.7461L40.5801 82.916L48.0465 72.0698L47.6662 71.8999Z",
    fill: "#C38B2C"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M48.6279 72.4503L41.1591 83.2954L41.5394 83.4653L49.0082 72.6202L48.6279 72.4503Z",
    fill: "#C38B2C"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M49.6083 72.9917L42.1419 83.8379L42.5222 84.0078L49.9886 73.1616L49.6083 72.9917Z",
    fill: "#C38B2C"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M50.5976 73.546L43.1288 84.3911L43.5091 84.5611L50.9779 73.7159L50.5976 73.546Z",
    fill: "#C38B2C"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M51.5897 74.0899L44.1209 84.9351L44.5012 85.105L51.97 74.2598L51.5897 74.0899Z",
    fill: "#C38B2C"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M52.6143 74.646L45.1478 85.4922L45.5281 85.6621L52.9946 74.8159L52.6143 74.646Z",
    fill: "#C38B2C"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M53.6541 75.1978L46.1853 86.043L46.5656 86.2129L54.0343 75.3678L53.6541 75.1978Z",
    fill: "#C38B2C"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M54.7103 75.7568L47.2438 86.603L47.6241 86.7729L55.0906 75.9267L54.7103 75.7568Z",
    fill: "#C38B2C"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M55.7636 76.2969L48.2949 87.1421L48.6751 87.312L56.1439 76.4669L55.7636 76.2969Z",
    fill: "#C38B2C"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M56.8472 76.8437L49.3807 87.6899L49.761 87.8598L57.2275 77.0136L56.8472 76.8437Z",
    fill: "#C38B2C"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M57.9384 77.4004L50.472 88.2466L50.8523 88.4165L58.3187 77.5703L57.9384 77.4004Z",
    fill: "#C38B2C"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M59.0353 77.9473L51.5688 88.7935L51.9491 88.9633L59.4156 78.1171L59.0353 77.9473Z",
    fill: "#C38B2C"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M60.1576 78.4947L52.6888 89.3398L53.0691 89.5098L60.5379 78.6646L60.1576 78.4947Z",
    fill: "#C38B2C"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M61.2998 79.0532L53.8334 89.8994L54.2137 90.0693L61.6801 79.2231L61.2998 79.0532Z",
    fill: "#C38B2C"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M62.4463 79.5928L54.9775 90.438L55.3578 90.6079L62.8266 79.7628L62.4463 79.5928Z",
    fill: "#C38B2C"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M63.5982 80.1284L56.1318 90.9746L56.5121 91.1445L63.9785 80.2983L63.5982 80.1284Z",
    fill: "#C38B2C"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M64.7946 80.6772L57.3306 91.5244L57.7109 91.6942L65.175 80.847L64.7946 80.6772Z",
    fill: "#C38B2C"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M65.9834 81.2198L58.5146 92.0649L58.8949 92.2349L66.3637 81.3897L65.9834 81.2198Z",
    fill: "#C38B2C"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M67.1993 81.7739L59.7329 92.6201L60.1132 92.79L67.5796 81.9438L67.1993 81.7739Z",
    fill: "#C38B2C"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M68.3951 82.2974L60.9287 93.1436L61.309 93.3134L68.7754 82.4672L68.3951 82.2974Z",
    fill: "#C38B2C"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M69.5864 82.8031L62.1223 93.6504L62.5027 93.8202L69.9667 82.973L69.5864 82.8031Z",
    fill: "#C38B2C"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M70.7898 83.3208L63.3234 94.167L63.7037 94.3369L71.1701 83.4907L70.7898 83.3208Z",
    fill: "#C38B2C"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M71.9721 83.8135L64.5057 94.6597L64.886 94.8296L72.3524 83.9834L71.9721 83.8135Z",
    fill: "#C38B2C"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M73.142 84.3008L65.6755 95.147L66.0558 95.3169L73.5223 84.4707L73.142 84.3008Z",
    fill: "#C38B2C"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M74.3222 84.7705L66.8558 95.6167L67.2361 95.7866L74.7025 84.9404L74.3222 84.7705Z",
    fill: "#C38B2C"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M75.4681 85.231L68.0017 96.0771L68.382 96.247L75.8484 85.4008L75.4681 85.231Z",
    fill: "#C38B2C"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M76.6335 85.687L69.1671 96.5332L69.5474 96.7031L77.0138 85.8569L76.6335 85.687Z",
    fill: "#C38B2C"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M77.7783 86.1357L70.3119 96.9819L70.6922 97.1518L78.1586 86.3056L77.7783 86.1357Z",
    fill: "#C38B2C"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M78.9152 86.5508L71.4487 97.397L71.829 97.5669L79.2955 86.7207L78.9152 86.5508Z",
    fill: "#C38B2C"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M80.0532 86.9902L72.5868 97.8364L72.9671 98.0063L80.4335 87.1601L80.0532 86.9902Z",
    fill: "#C38B2C"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M81.1788 87.4028L73.7123 98.249L74.0926 98.4189L81.5591 87.5727L81.1788 87.4028Z",
    fill: "#C38B2C"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M82.2945 87.8057L74.8257 98.6509L75.206 98.8208L82.6748 87.9757L82.2945 87.8057Z",
    fill: "#C38B2C"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M83.4036 88.2012L75.9371 99.0474L76.3174 99.2172L83.7839 88.3711L83.4036 88.2012Z",
    fill: "#C38B2C"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M84.5003 88.5831L77.0316 99.4282L77.4118 99.5982L84.8806 88.753L84.5003 88.5831Z",
    fill: "#C38B2C"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M85.609 88.9674L78.1402 99.8125L78.5205 99.9824L85.9892 89.1373L85.609 88.9674Z",
    fill: "#C38B2C"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M86.6719 89.3228L79.2055 100.169L79.5858 100.339L87.0522 89.4926L86.6719 89.3228Z",
    fill: "#C38B2C"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M87.7405 89.6738L80.2764 100.521L80.6568 100.691L88.1208 89.8436L87.7405 89.6738Z",
    fill: "#C38B2C"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M88.7975 90.0269L81.3311 100.873L81.7114 101.043L89.1778 90.1967L88.7975 90.0269Z",
    fill: "#C38B2C"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M89.8572 90.3667L82.3907 101.213L82.771 101.383L90.2375 90.5366L89.8572 90.3667Z",
    fill: "#C38B2C"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M90.8842 90.6918L83.4201 101.539L83.8004 101.709L91.2645 90.8616L90.8842 90.6918Z",
    fill: "#C38B2C"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M91.9269 91.0176L84.4605 101.864L84.8408 102.034L92.3072 91.1875L91.9269 91.0176Z",
    fill: "#C38B2C"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M92.9287 91.3256L85.4646 102.173L85.8449 102.343L93.309 91.4954L92.9287 91.3256Z",
    fill: "#C38B2C"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M93.9606 91.6489L86.4942 102.495L86.8745 102.665L94.3409 91.8188L93.9606 91.6489Z",
    fill: "#C38B2C"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M94.9368 91.9252L87.4727 102.772L87.8531 102.942L95.3171 92.095L94.9368 91.9252Z",
    fill: "#C38B2C"
  }))))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    },
    opacity: 0.23
  }, _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M65.2804 73.64C60.4414 71.7245 55.8523 70.2338 51.8738 69.25L42.7232 82.5317C45.869 84.723 49.866 87.0708 54.4459 89.3664L65.2804 73.6474V73.64Z",
    fill: "#FFFAEF"
  }))), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "M95.2766 94.509C93.056 97.7288 78.5483 94.6506 62.8564 87.6445C47.1737 80.6384 36.2467 72.3429 38.4672 69.1306C40.6878 65.9182 55.1954 68.989 70.8874 75.995C86.5701 83.0011 97.4971 91.2966 95.2766 94.509Z",
    fill: "url(#paint1_linear_13193_55427)"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    },
    opacity: 0.33
  }, _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    d: "M59.6735 84.8422C62.9674 84.9615 66.252 85.1255 69.5458 85.2C72.8211 85.2745 76.0965 85.3044 79.3718 85.3267C82.2493 85.3416 85.1267 85.3565 88.0042 85.3714C85.4135 83.5677 82.2493 81.6597 78.6501 79.7591C76.9199 79.692 75.199 79.625 73.4688 79.5579C68.8889 79.3715 64.2997 79.1778 59.7198 78.9318C55.1584 78.6858 50.6063 78.3877 46.0541 78.1343C45.8783 78.1268 45.7025 78.1194 45.5267 78.1045C48.5615 80.2361 52.4105 82.5094 56.8146 84.7454C57.7676 84.7677 58.7206 84.7901 59.6735 84.8273V84.8422Z",
    fill: "#FFFAEF"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask1_13193_55427",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 44,
    y: 70,
    width: 46,
    height: 23
  }, _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    d: "M89.2904 91.2219C87.7452 93.4653 76.5961 90.8641 64.4016 85.4158C52.1977 79.9674 43.5653 73.729 45.1105 71.4856C46.6556 69.2422 57.8047 71.8434 69.9992 77.2917C82.2031 82.7401 90.8355 88.9784 89.2904 91.2219Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_13193_55427)"
  }, _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    d: "M89.2905 91.2219C87.7454 93.4653 76.5963 90.8641 64.4018 85.4158C52.1979 79.9674 43.5655 73.729 45.1106 71.4856C46.6558 69.2422 57.8048 71.8434 69.9994 77.2917C82.2032 82.7401 90.8357 88.9784 89.2905 91.2219Z",
    fill: "url(#paint2_linear_13193_55427)"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    d: "M88.504 93.1369C86.9588 95.3803 75.8098 92.7792 63.6152 87.3308C51.4114 81.8825 42.7789 75.6441 44.3241 73.4006C45.8692 71.1572 57.0183 73.7584 69.2129 79.2067C81.4167 84.6551 90.0491 90.8935 88.504 93.1369Z",
    fill: "url(#paint3_linear_13193_55427)"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    },
    opacity: 0.11
  }, _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    d: "M47.6365 78.0073L76.2725 79.7737L86.2002 85.5128L59.5627 85.0432L47.6365 78.0073Z",
    fill: "#FFFAEF"
  })))), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    d: "M93.3337 95.5746C92.0476 95.91 90.669 95.9026 89.3367 95.8504L88.3282 95.7908L87.3289 95.6864C86.6627 95.6268 86.0058 95.515 85.3397 95.4256C82.7028 95.0007 80.1306 94.3896 77.6047 93.6666C72.5437 92.2356 67.6862 90.3946 62.986 88.3375C60.6452 87.2941 58.3414 86.1984 56.093 85.0283C53.8632 83.8432 51.6519 82.6134 49.5424 81.2793C47.4328 79.9526 45.3973 78.5439 43.5099 77.0011C42.5754 76.2259 41.6779 75.4135 40.8544 74.5639C40.0402 73.7067 39.2723 72.8049 38.7542 71.8062C40.1142 73.662 42.011 75.1825 43.9817 76.5912C45.9525 78.0147 48.0528 79.3116 50.1993 80.5637C54.5016 83.0457 59.0168 85.2891 63.6522 87.3462C68.2876 89.4033 73.0618 91.2666 77.9748 92.8467C80.4359 93.6293 82.9341 94.3448 85.4877 94.8889C86.1261 95.0231 86.7645 95.1722 87.4122 95.269L88.3837 95.433L89.3644 95.5523C90.669 95.6715 92.0106 95.7833 93.3244 95.5672L93.3337 95.5746Z",
    fill: "#FEDE9A"
  }))), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_d_13193_55427)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask2_13193_55427",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 124,
    y: 8,
    width: 55,
    height: 40
  }, _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    d: "M174.298 9.73124C171.355 6.9139 157.847 12.1834 144.126 21.4925C130.405 30.8016 121.67 40.6325 124.613 43.4498C125.307 44.1132 127.851 46.5429 128.545 47.2063C131.487 50.0236 144.996 44.7542 158.717 35.445C172.438 26.1359 181.172 16.305 178.23 13.4877C177.536 12.8243 174.992 10.3946 174.298 9.73124Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask2_13193_55427)"
  }, _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    d: "M174.298 9.73124C171.355 6.9139 157.847 12.1834 144.126 21.4925C130.405 30.8016 121.67 40.6325 124.613 43.4498C125.307 44.1132 127.851 46.5429 128.545 47.2063C131.487 50.0236 144.996 44.7542 158.717 35.445C172.438 26.1359 181.172 16.305 178.23 13.4877C177.536 12.8243 174.992 10.3946 174.298 9.73124Z",
    fill: "url(#paint4_linear_13193_55427)"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.68
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    d: "M123.906 41.1288L123.573 41.3545L133.492 50.8398L133.825 50.6142L123.906 41.1288Z",
    fill: "#C38B2C"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    d: "M124.817 40.6683L124.484 40.894L134.405 50.378L134.738 50.1523L124.817 40.6683Z",
    fill: "#C38B2C"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    d: "M125.742 40.2265L125.409 40.4521L135.328 49.9375L135.661 49.7118L125.742 40.2265Z",
    fill: "#C38B2C"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    d: "M126.667 39.7464L126.335 39.9722L136.256 49.4561L136.588 49.2304L126.667 39.7464Z",
    fill: "#C38B2C"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    d: "M127.602 39.2694L127.269 39.4951L137.19 48.9791L137.523 48.7533L127.602 39.2694Z",
    fill: "#C38B2C"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    d: "M128.553 38.7978L128.22 39.0234L138.139 48.5088L138.472 48.2831L128.553 38.7978Z",
    fill: "#C38B2C"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    d: "M129.496 38.285L129.164 38.5107L139.084 47.9947L139.417 47.769L129.496 38.285Z",
    fill: "#C38B2C"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    d: "M130.471 37.7943L130.139 38.02L140.058 47.5054L140.39 47.2797L130.471 37.7943Z",
    fill: "#C38B2C"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    d: "M131.435 37.2709L131.103 37.4966L141.022 46.9819L141.354 46.7562L131.435 37.2709Z",
    fill: "#C38B2C"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    d: "M132.412 36.7421L132.079 36.9678L141.998 46.4531L142.331 46.2274L132.412 36.7421Z",
    fill: "#C38B2C"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    d: "M133.383 36.1942L133.05 36.4199L142.971 45.9039L143.304 45.6781L133.383 36.1942Z",
    fill: "#C38B2C"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    d: "M134.365 35.639L134.032 35.8647L143.953 45.3487L144.286 45.123L134.365 35.639Z",
    fill: "#C38B2C"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    d: "M135.374 35.0814L135.042 35.3071L144.96 44.7925L145.293 44.5668L135.374 35.0814Z",
    fill: "#C38B2C"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    d: "M136.379 34.5248L136.047 34.7505L145.965 44.2358L146.298 44.0101L136.379 34.5248Z",
    fill: "#C38B2C"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    d: "M137.381 33.9354L137.048 34.1611L146.969 43.6451L147.302 43.4194L137.381 33.9354Z",
    fill: "#C38B2C"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    d: "M138.396 33.3524L138.063 33.5781L147.982 43.0635L148.314 42.8378L138.396 33.3524Z",
    fill: "#C38B2C"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    d: "M139.413 32.7426L139.08 32.9683L148.999 42.4536L149.332 42.2279L139.413 32.7426Z",
    fill: "#C38B2C"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path80 || (_path80 = /*#__PURE__*/React.createElement("path", {
    d: "M140.441 32.1298L140.108 32.3555L150.027 41.8408L150.359 41.6151L140.441 32.1298Z",
    fill: "#C38B2C"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path81 || (_path81 = /*#__PURE__*/React.createElement("path", {
    d: "M141.465 31.5053L141.133 31.731L151.052 41.2163L151.384 40.9906L141.465 31.5053Z",
    fill: "#C38B2C"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path82 || (_path82 = /*#__PURE__*/React.createElement("path", {
    d: "M142.495 30.8563L142.162 31.082L152.083 40.566L152.416 40.3403L142.495 30.8563Z",
    fill: "#C38B2C"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path83 || (_path83 = /*#__PURE__*/React.createElement("path", {
    d: "M143.527 30.202L143.195 30.4277L153.116 39.9117L153.448 39.686L143.527 30.202Z",
    fill: "#C38B2C"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path84 || (_path84 = /*#__PURE__*/React.createElement("path", {
    d: "M144.572 29.5521L144.24 29.7778L154.159 39.2632L154.491 39.0375L144.572 29.5521Z",
    fill: "#C38B2C"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path85 || (_path85 = /*#__PURE__*/React.createElement("path", {
    d: "M145.616 28.8856L145.284 29.1113L155.202 38.5967L155.535 38.371L145.616 28.8856Z",
    fill: "#C38B2C"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path86 || (_path86 = /*#__PURE__*/React.createElement("path", {
    d: "M146.676 28.1996L146.344 28.4253L156.262 37.9106L156.595 37.685L146.676 28.1996Z",
    fill: "#C38B2C"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path87 || (_path87 = /*#__PURE__*/React.createElement("path", {
    d: "M147.726 27.5141L147.394 27.7397L157.313 37.2251L157.645 36.9994L147.726 27.5141Z",
    fill: "#C38B2C"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path88 || (_path88 = /*#__PURE__*/React.createElement("path", {
    d: "M148.771 26.7967L148.438 27.0225L158.359 36.5064L158.691 36.2807L148.771 26.7967Z",
    fill: "#C38B2C"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path89 || (_path89 = /*#__PURE__*/React.createElement("path", {
    d: "M149.839 26.0907L149.506 26.3164L159.425 35.8018L159.758 35.5761L149.839 26.0907Z",
    fill: "#C38B2C"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path90 || (_path90 = /*#__PURE__*/React.createElement("path", {
    d: "M150.875 25.3681L150.542 25.5938L160.461 35.0791L160.793 34.8534L150.875 25.3681Z",
    fill: "#C38B2C"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path91 || (_path91 = /*#__PURE__*/React.createElement("path", {
    d: "M151.891 24.6366L151.558 24.8623L161.479 34.3463L161.812 34.1205L151.891 24.6366Z",
    fill: "#C38B2C"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path92 || (_path92 = /*#__PURE__*/React.createElement("path", {
    d: "M152.917 23.9418L152.585 24.1675L162.501 33.6542L162.834 33.4286L152.917 23.9418Z",
    fill: "#C38B2C"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path93 || (_path93 = /*#__PURE__*/React.createElement("path", {
    d: "M153.918 23.223L153.586 23.4487L163.504 32.9341L163.837 32.7084L153.918 23.223Z",
    fill: "#C38B2C"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path94 || (_path94 = /*#__PURE__*/React.createElement("path", {
    d: "M154.892 22.5097L154.559 22.7354L164.478 32.2207L164.811 31.995L154.892 22.5097Z",
    fill: "#C38B2C"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path95 || (_path95 = /*#__PURE__*/React.createElement("path", {
    d: "M155.851 21.7982L155.518 22.0239L165.437 31.5093L165.77 31.2836L155.851 21.7982Z",
    fill: "#C38B2C"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path96 || (_path96 = /*#__PURE__*/React.createElement("path", {
    d: "M156.797 21.0809L156.464 21.3066L166.385 30.7906L166.718 30.5649L156.797 21.0809Z",
    fill: "#C38B2C"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path97 || (_path97 = /*#__PURE__*/React.createElement("path", {
    d: "M157.751 20.3793L157.419 20.605L167.337 30.0903L167.67 29.8646L157.751 20.3793Z",
    fill: "#C38B2C"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path98 || (_path98 = /*#__PURE__*/React.createElement("path", {
    d: "M158.663 19.6757L158.33 19.9014L168.249 29.3867L168.582 29.161L158.663 19.6757Z",
    fill: "#C38B2C"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path99 || (_path99 = /*#__PURE__*/React.createElement("path", {
    d: "M159.58 18.9628L159.248 19.1885L169.167 28.6738L169.499 28.4482L159.58 18.9628Z",
    fill: "#C38B2C"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path100 || (_path100 = /*#__PURE__*/React.createElement("path", {
    d: "M160.476 18.2714L160.144 18.4971L170.063 27.9824L170.395 27.7567L160.476 18.2714Z",
    fill: "#C38B2C"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path101 || (_path101 = /*#__PURE__*/React.createElement("path", {
    d: "M161.343 17.5604L161.01 17.7861L170.931 27.2701L171.264 27.0443L161.343 17.5604Z",
    fill: "#C38B2C"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path102 || (_path102 = /*#__PURE__*/React.createElement("path", {
    d: "M162.212 16.8621L161.88 17.0879L171.801 26.5718L172.133 26.3461L162.212 16.8621Z",
    fill: "#C38B2C"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path103 || (_path103 = /*#__PURE__*/React.createElement("path", {
    d: "M163.072 16.183L162.739 16.4087L172.658 25.894L172.991 25.6683L163.072 16.183Z",
    fill: "#C38B2C"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path104 || (_path104 = /*#__PURE__*/React.createElement("path", {
    d: "M163.89 15.4793L163.557 15.7051L173.478 25.189L173.811 24.9633L163.89 15.4793Z",
    fill: "#C38B2C"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path105 || (_path105 = /*#__PURE__*/React.createElement("path", {
    d: "M164.716 14.7983L164.383 15.0239L174.302 24.5093L174.635 24.2836L164.716 14.7983Z",
    fill: "#C38B2C"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path106 || (_path106 = /*#__PURE__*/React.createElement("path", {
    d: "M165.531 14.1161L165.199 14.3418L175.12 23.8257L175.452 23.6L165.531 14.1161Z",
    fill: "#C38B2C"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path107 || (_path107 = /*#__PURE__*/React.createElement("path", {
    d: "M166.328 13.4374L165.996 13.6631L175.917 23.147L176.249 22.9213L166.328 13.4374Z",
    fill: "#C38B2C"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path108 || (_path108 = /*#__PURE__*/React.createElement("path", {
    d: "M167.107 12.7631L166.775 12.9888L176.694 22.4741L177.026 22.2484L167.107 12.7631Z",
    fill: "#C38B2C"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path109 || (_path109 = /*#__PURE__*/React.createElement("path", {
    d: "M167.88 12.0975L167.547 12.3232L177.466 21.8086L177.799 21.5829L167.88 12.0975Z",
    fill: "#C38B2C"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path110 || (_path110 = /*#__PURE__*/React.createElement("path", {
    d: "M168.642 11.4349L168.309 11.6606L178.228 21.146L178.561 20.9203L168.642 11.4349Z",
    fill: "#C38B2C"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path111 || (_path111 = /*#__PURE__*/React.createElement("path", {
    d: "M169.387 10.7768L169.054 11.0024L178.971 20.4892L179.304 20.2635L169.387 10.7768Z",
    fill: "#C38B2C"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path112 || (_path112 = /*#__PURE__*/React.createElement("path", {
    d: "M170.093 10.1147L169.76 10.3403L179.679 19.8257L180.012 19.6L170.093 10.1147Z",
    fill: "#C38B2C"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path113 || (_path113 = /*#__PURE__*/React.createElement("path", {
    d: "M170.814 9.45833L170.481 9.68408L180.402 19.168L180.734 18.9423L170.814 9.45833Z",
    fill: "#C38B2C"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path114 || (_path114 = /*#__PURE__*/React.createElement("path", {
    d: "M171.517 8.8202L171.184 9.0459L181.103 18.5312L181.436 18.3055L171.517 8.8202Z",
    fill: "#C38B2C"
  }))))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    },
    opacity: 0.23
  }, _path115 || (_path115 = /*#__PURE__*/React.createElement("path", {
    d: "M139.398 24.8691C135.456 27.8281 132.089 30.7498 129.526 33.3957L141.674 45.0153C145.338 43.4278 149.483 41.2514 153.776 38.6279L139.398 24.8691Z",
    fill: "#FFFAEF"
  }))), _path116 || (_path116 = /*#__PURE__*/React.createElement("path", {
    d: "M174.298 9.73144C177.24 12.5488 168.506 22.3796 154.784 31.6888C141.063 40.9979 127.555 46.2599 124.613 43.45C121.67 40.6327 130.405 30.8018 144.126 21.4927C157.847 12.1836 171.355 6.92156 174.298 9.73144Z",
    fill: "url(#paint5_linear_13193_55427)"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    },
    opacity: 0.33
  }, _path117 || (_path117 = /*#__PURE__*/React.createElement("path", {
    d: "M150.399 33.0823C151.713 30.6451 153.073 28.2302 154.34 25.7781C155.599 23.3409 156.801 20.8813 157.986 18.4217C159.031 16.2603 160.068 14.0988 161.113 11.9448C158.097 13.2566 154.757 14.9559 151.278 16.9832C150.584 18.2577 149.89 19.5323 149.196 20.8068C147.355 24.1905 145.495 27.5743 143.571 30.9283C141.665 34.2748 139.694 37.5915 137.779 40.9306C137.705 41.0573 137.631 41.1915 137.557 41.3182C141.11 39.7977 145.125 37.7108 149.289 35.1916C149.659 34.4835 150.02 33.7755 150.399 33.0674V33.0823Z",
    fill: "#FFFAEF"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask3_13193_55427",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 129,
    y: 12,
    width: 40,
    height: 28
  }, _path118 || (_path118 = /*#__PURE__*/React.createElement("path", {
    d: "M168.348 13.0626C170.402 15.0228 163.417 22.491 152.74 29.7281C142.072 36.9727 131.755 41.2509 129.701 39.2832C127.647 37.323 134.633 29.8548 145.31 22.6177C155.978 15.3731 166.294 11.0949 168.348 13.0626Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask3_13193_55427)"
  }, _path119 || (_path119 = /*#__PURE__*/React.createElement("path", {
    d: "M168.348 13.0626C170.402 15.0228 163.417 22.491 152.74 29.7281C142.072 36.9727 131.755 41.2509 129.701 39.2832C127.647 37.323 134.633 29.8548 145.31 22.6177C155.978 15.3731 166.294 11.0949 168.348 13.0626Z",
    fill: "url(#paint6_linear_13193_55427)"
  })), _path120 || (_path120 = /*#__PURE__*/React.createElement("path", {
    d: "M170.292 14.3448C172.346 16.305 165.36 23.7732 154.683 31.0103C144.015 38.2549 133.699 42.5331 131.645 40.5654C129.59 38.6052 136.576 31.137 147.253 23.8999C157.921 16.6553 168.238 12.3771 170.292 14.3448Z",
    fill: "url(#paint7_linear_13193_55427)"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    },
    opacity: 0.11
  }, _path121 || (_path121 = /*#__PURE__*/React.createElement("path", {
    d: "M138.177 39.7083L150.436 18.787L160.623 13.3535L150.584 33.2314L138.177 39.7083Z",
    fill: "#FFFAEF"
  })))), _path122 || (_path122 = /*#__PURE__*/React.createElement("path", {
    d: "M174.844 11.5723C174.77 12.6604 174.279 13.689 173.743 14.6803L173.317 15.4182L172.845 16.1337C172.54 16.6181 172.179 17.0728 171.837 17.5349C170.402 19.3684 168.774 21.0901 167.044 22.7298C163.583 26.0316 159.716 29.0278 155.654 31.8303C153.609 33.2166 151.518 34.5656 149.363 35.8401C147.188 37.0997 144.986 38.3221 142.682 39.4326C140.397 40.5506 138.029 41.5791 135.567 42.4512C134.337 42.8835 133.079 43.2636 131.792 43.5841C130.506 43.8896 129.193 44.1505 127.851 44.1803C130.488 43.8226 132.921 42.9282 135.262 41.9443C137.612 40.968 139.87 39.85 142.081 38.6798C146.494 36.3246 150.704 33.7308 154.738 30.9657C158.782 28.208 162.64 25.2788 166.22 22.1485C168.006 20.5758 169.727 18.951 171.272 17.2218C171.652 16.7896 172.049 16.3647 172.401 15.9101L172.938 15.2393L173.419 14.5461C174.029 13.607 174.631 12.6381 174.844 11.5723Z",
    fill: "#FEDE9A"
  }))), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter2_d_13193_55427)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask4_13193_55427",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 109,
    y: 210,
    width: 60,
    height: 34
  }, _path123 || (_path123 = /*#__PURE__*/React.createElement("path", {
    d: "M165.456 211.422C163.096 208.269 148.737 211.772 133.378 219.233C118.019 226.694 107.48 235.31 109.84 238.462C110.395 239.208 112.43 241.928 112.995 242.674C115.354 245.826 129.714 242.323 145.073 234.862C160.432 227.394 170.97 218.786 168.611 215.633C168.055 214.888 166.02 212.167 165.456 211.422Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask4_13193_55427)"
  }, _path124 || (_path124 = /*#__PURE__*/React.createElement("path", {
    d: "M165.455 211.422C163.096 208.269 148.736 211.772 133.377 219.233C118.019 226.694 107.48 235.31 109.84 238.462C110.395 239.208 112.43 241.928 112.995 242.674C115.354 245.826 129.714 242.323 145.072 234.862C160.431 227.394 170.97 218.786 168.61 215.633C168.055 214.888 166.02 212.167 165.455 211.422Z",
    fill: "url(#paint8_linear_13193_55427)"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.68
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path125 || (_path125 = /*#__PURE__*/React.createElement("path", {
    d: "M109.615 236.081L109.243 236.262L117.2 246.88L117.572 246.699L109.615 236.081Z",
    fill: "#C38B2C"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path126 || (_path126 = /*#__PURE__*/React.createElement("path", {
    d: "M110.575 235.769L110.203 235.95L118.157 246.568L118.53 246.387L110.575 235.769Z",
    fill: "#C38B2C"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path127 || (_path127 = /*#__PURE__*/React.createElement("path", {
    d: "M111.605 235.416L111.232 235.597L119.19 246.214L119.562 246.033L111.605 235.416Z",
    fill: "#C38B2C"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path128 || (_path128 = /*#__PURE__*/React.createElement("path", {
    d: "M112.553 235.105L112.18 235.286L120.135 245.905L120.508 245.724L112.553 235.105Z",
    fill: "#C38B2C"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path129 || (_path129 = /*#__PURE__*/React.createElement("path", {
    d: "M113.607 234.739L113.234 234.92L121.189 245.539L121.561 245.358L113.607 234.739Z",
    fill: "#C38B2C"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path130 || (_path130 = /*#__PURE__*/React.createElement("path", {
    d: "M114.631 234.372L114.259 234.553L122.213 245.171L122.586 244.99L114.631 234.372Z",
    fill: "#C38B2C"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path131 || (_path131 = /*#__PURE__*/React.createElement("path", {
    d: "M115.686 233.994L115.314 234.175L123.271 244.792L123.644 244.611L115.686 233.994Z",
    fill: "#C38B2C"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path132 || (_path132 = /*#__PURE__*/React.createElement("path", {
    d: "M116.688 233.639L116.316 233.82L124.27 244.439L124.643 244.258L116.688 233.639Z",
    fill: "#C38B2C"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path133 || (_path133 = /*#__PURE__*/React.createElement("path", {
    d: "M117.795 233.217L117.423 233.398L125.382 244.015L125.755 243.834L117.795 233.217Z",
    fill: "#C38B2C"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path134 || (_path134 = /*#__PURE__*/React.createElement("path", {
    d: "M118.837 232.833L118.464 233.014L126.422 243.632L126.794 243.451L118.837 232.833Z",
    fill: "#C38B2C"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path135 || (_path135 = /*#__PURE__*/React.createElement("path", {
    d: "M119.942 232.415L119.569 232.596L127.526 243.213L127.899 243.032L119.942 232.415Z",
    fill: "#C38B2C"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path136 || (_path136 = /*#__PURE__*/React.createElement("path", {
    d: "M120.999 232.01L120.627 232.191L128.581 242.81L128.954 242.629L120.999 232.01Z",
    fill: "#C38B2C"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path137 || (_path137 = /*#__PURE__*/React.createElement("path", {
    d: "M122.109 231.565L121.737 231.746L129.694 242.363L130.066 242.182L122.109 231.565Z",
    fill: "#C38B2C"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path138 || (_path138 = /*#__PURE__*/React.createElement("path", {
    d: "M123.187 231.141L122.815 231.322L130.769 241.94L131.142 241.759L123.187 231.141Z",
    fill: "#C38B2C"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path139 || (_path139 = /*#__PURE__*/React.createElement("path", {
    d: "M124.295 230.691L123.922 230.872L131.877 241.491L132.249 241.31L124.295 230.691Z",
    fill: "#C38B2C"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path140 || (_path140 = /*#__PURE__*/React.createElement("path", {
    d: "M125.433 230.226L125.061 230.407L133.018 241.024L133.39 240.843L125.433 230.226Z",
    fill: "#C38B2C"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path141 || (_path141 = /*#__PURE__*/React.createElement("path", {
    d: "M126.561 229.748L126.189 229.929L134.146 240.547L134.518 240.366L126.561 229.748Z",
    fill: "#C38B2C"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path142 || (_path142 = /*#__PURE__*/React.createElement("path", {
    d: "M127.667 229.29L127.295 229.471L135.25 240.089L135.622 239.908L127.667 229.29Z",
    fill: "#C38B2C"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path143 || (_path143 = /*#__PURE__*/React.createElement("path", {
    d: "M128.807 228.797L128.435 228.978L136.39 239.597L136.762 239.416L128.807 228.797Z",
    fill: "#C38B2C"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path144 || (_path144 = /*#__PURE__*/React.createElement("path", {
    d: "M129.915 228.321L129.542 228.502L137.497 239.12L137.87 238.939L129.915 228.321Z",
    fill: "#C38B2C"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path145 || (_path145 = /*#__PURE__*/React.createElement("path", {
    d: "M131.123 227.776L130.751 227.957L138.708 238.574L139.081 238.393L131.123 227.776Z",
    fill: "#C38B2C"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path146 || (_path146 = /*#__PURE__*/React.createElement("path", {
    d: "M132.253 227.267L131.881 227.448L139.836 238.067L140.208 237.886L132.253 227.267Z",
    fill: "#C38B2C"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path147 || (_path147 = /*#__PURE__*/React.createElement("path", {
    d: "M133.413 226.743L133.041 226.924L140.995 237.542L141.368 237.361L133.413 226.743Z",
    fill: "#C38B2C"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path148 || (_path148 = /*#__PURE__*/React.createElement("path", {
    d: "M134.613 226.18L134.24 226.361L142.197 236.979L142.57 236.798L134.613 226.18Z",
    fill: "#C38B2C"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path149 || (_path149 = /*#__PURE__*/React.createElement("path", {
    d: "M135.768 225.647L135.395 225.828L143.35 236.446L143.722 236.265L135.768 225.647Z",
    fill: "#C38B2C"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path150 || (_path150 = /*#__PURE__*/React.createElement("path", {
    d: "M136.938 225.083L136.565 225.264L144.52 235.882L144.893 235.701L136.938 225.083Z",
    fill: "#C38B2C"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path151 || (_path151 = /*#__PURE__*/React.createElement("path", {
    d: "M138.12 224.501L137.748 224.682L145.703 235.3L146.075 235.119L138.12 224.501Z",
    fill: "#C38B2C"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path152 || (_path152 = /*#__PURE__*/React.createElement("path", {
    d: "M139.292 223.927L138.919 224.108L146.874 234.727L147.246 234.546L139.292 223.927Z",
    fill: "#C38B2C"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path153 || (_path153 = /*#__PURE__*/React.createElement("path", {
    d: "M140.448 223.343L140.075 223.524L148.032 234.142L148.405 233.961L140.448 223.343Z",
    fill: "#C38B2C"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path154 || (_path154 = /*#__PURE__*/React.createElement("path", {
    d: "M141.59 222.756L141.218 222.938L149.177 233.554L149.55 233.373L141.59 222.756Z",
    fill: "#C38B2C"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path155 || (_path155 = /*#__PURE__*/React.createElement("path", {
    d: "M142.701 222.19L142.329 222.371L150.284 232.989L150.656 232.808L142.701 222.19Z",
    fill: "#C38B2C"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path156 || (_path156 = /*#__PURE__*/React.createElement("path", {
    d: "M143.803 221.613L143.431 221.794L151.386 232.412L151.758 232.231L143.803 221.613Z",
    fill: "#C38B2C"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path157 || (_path157 = /*#__PURE__*/React.createElement("path", {
    d: "M144.933 221.011L144.56 221.192L152.517 231.81L152.89 231.629L144.933 221.011Z",
    fill: "#C38B2C"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path158 || (_path158 = /*#__PURE__*/React.createElement("path", {
    d: "M145.983 220.45L145.611 220.631L153.566 231.25L153.938 231.069L145.983 220.45Z",
    fill: "#C38B2C"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path159 || (_path159 = /*#__PURE__*/React.createElement("path", {
    d: "M147.062 219.857L146.69 220.038L154.647 230.655L155.019 230.474L147.062 219.857Z",
    fill: "#C38B2C"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path160 || (_path160 = /*#__PURE__*/React.createElement("path", {
    d: "M148.089 219.292L147.717 219.473L155.671 230.092L156.044 229.911L148.089 219.292Z",
    fill: "#C38B2C"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path161 || (_path161 = /*#__PURE__*/React.createElement("path", {
    d: "M149.131 218.706L148.758 218.887L156.713 229.506L157.086 229.325L149.131 218.706Z",
    fill: "#C38B2C"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path162 || (_path162 = /*#__PURE__*/React.createElement("path", {
    d: "M150.147 218.128L149.775 218.309L157.73 228.927L158.102 228.746L150.147 218.128Z",
    fill: "#C38B2C"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path163 || (_path163 = /*#__PURE__*/React.createElement("path", {
    d: "M151.168 217.527L150.796 217.708L158.753 228.325L159.126 228.144L151.168 217.527Z",
    fill: "#C38B2C"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path164 || (_path164 = /*#__PURE__*/React.createElement("path", {
    d: "M152.14 216.964L151.767 217.145L159.722 227.763L160.095 227.582L152.14 216.964Z",
    fill: "#C38B2C"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path165 || (_path165 = /*#__PURE__*/React.createElement("path", {
    d: "M153.112 216.388L152.74 216.569L160.695 227.188L161.067 227.007L153.112 216.388Z",
    fill: "#C38B2C"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path166 || (_path166 = /*#__PURE__*/React.createElement("path", {
    d: "M154.077 215.817L153.704 215.998L161.659 226.617L162.032 226.436L154.077 215.817Z",
    fill: "#C38B2C"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path167 || (_path167 = /*#__PURE__*/React.createElement("path", {
    d: "M155.024 215.242L154.652 215.423L162.607 226.041L162.979 225.86L155.024 215.242Z",
    fill: "#C38B2C"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path168 || (_path168 = /*#__PURE__*/React.createElement("path", {
    d: "M155.969 214.66L155.596 214.841L163.554 225.458L163.926 225.277L155.969 214.66Z",
    fill: "#C38B2C"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path169 || (_path169 = /*#__PURE__*/React.createElement("path", {
    d: "M156.889 214.084L156.517 214.265L164.474 224.883L164.846 224.701L156.889 214.084Z",
    fill: "#C38B2C"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path170 || (_path170 = /*#__PURE__*/React.createElement("path", {
    d: "M157.776 213.525L157.404 213.706L165.359 224.325L165.731 224.144L157.776 213.525Z",
    fill: "#C38B2C"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path171 || (_path171 = /*#__PURE__*/React.createElement("path", {
    d: "M158.669 212.967L158.297 213.148L166.251 223.767L166.624 223.586L158.669 212.967Z",
    fill: "#C38B2C"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path172 || (_path172 = /*#__PURE__*/React.createElement("path", {
    d: "M159.539 212.4L159.167 212.581L167.122 223.2L167.494 223.019L159.539 212.4Z",
    fill: "#C38B2C"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path173 || (_path173 = /*#__PURE__*/React.createElement("path", {
    d: "M160.418 211.827L160.046 212.008L168.003 222.626L168.375 222.445L160.418 211.827Z",
    fill: "#C38B2C"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path174 || (_path174 = /*#__PURE__*/React.createElement("path", {
    d: "M161.242 211.286L160.87 211.467L168.824 222.085L169.197 221.904L161.242 211.286Z",
    fill: "#C38B2C"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path175 || (_path175 = /*#__PURE__*/React.createElement("path", {
    d: "M162.073 210.728L161.701 210.909L169.655 221.527L170.028 221.346L162.073 210.728Z",
    fill: "#C38B2C"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path176 || (_path176 = /*#__PURE__*/React.createElement("path", {
    d: "M162.893 210.184L162.521 210.365L170.475 220.983L170.848 220.802L162.893 210.184Z",
    fill: "#C38B2C"
  }))))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    },
    opacity: 0.23
  }, _path177 || (_path177 = /*#__PURE__*/React.createElement("path", {
    d: "M128.039 221.983C123.57 224.413 119.675 226.872 116.631 229.16L126.374 242.166C130.306 241.063 134.821 239.438 139.567 237.381L128.039 221.983Z",
    fill: "#FFFAEF"
  }))), _path178 || (_path178 = /*#__PURE__*/React.createElement("path", {
    d: "M141.89 230.665C157.247 223.2 167.782 214.594 165.421 211.443C163.061 208.292 148.699 211.79 133.343 219.255C117.986 226.72 107.451 235.326 109.812 238.477C112.172 241.628 126.534 238.13 141.89 230.665Z",
    fill: "url(#paint9_linear_13193_55427)"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    },
    opacity: 0.33
  }, _path179 || (_path179 = /*#__PURE__*/React.createElement("path", {
    d: "M137.31 231.479C139.077 229.235 140.891 227.022 142.621 224.763C144.333 222.512 145.998 220.239 147.654 217.958C149.107 215.961 150.55 213.956 152.003 211.958C148.764 212.868 145.138 214.135 141.307 215.693C140.373 216.863 139.438 218.04 138.504 219.211C136.024 222.319 133.535 225.427 130.981 228.505C128.446 231.568 125.856 234.594 123.32 237.657C123.219 237.777 123.126 237.896 123.024 238.015C126.827 236.957 131.194 235.399 135.802 233.439C136.302 232.783 136.801 232.134 137.31 231.486V231.479Z",
    fill: "#FFFAEF"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask5_13193_55427",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 115,
    y: 213,
    width: 45,
    height: 23
  }, _path180 || (_path180 = /*#__PURE__*/React.createElement("path", {
    d: "M140.265 228.487C152.208 222.681 160.555 216.191 158.908 213.992C157.26 211.793 146.242 214.717 134.298 220.523C122.355 226.329 114.008 232.819 115.655 235.018C117.303 237.217 128.321 234.293 140.265 228.487Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask5_13193_55427)"
  }, _path181 || (_path181 = /*#__PURE__*/React.createElement("path", {
    d: "M140.265 228.487C152.208 222.681 160.555 216.191 158.908 213.992C157.26 211.793 146.242 214.717 134.298 220.523C122.355 226.329 114.008 232.819 115.655 235.018C117.303 237.217 128.321 234.293 140.265 228.487Z",
    fill: "url(#paint10_linear_13193_55427)"
  })), _path182 || (_path182 = /*#__PURE__*/React.createElement("path", {
    d: "M141.942 229.988C153.886 224.182 162.233 217.692 160.585 215.493C158.938 213.294 147.92 216.218 135.976 222.024C124.033 227.83 115.686 234.32 117.333 236.519C118.981 238.718 129.999 235.794 141.942 229.988Z",
    fill: "url(#paint11_linear_13193_55427)"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    },
    opacity: 0.11
  }, _path183 || (_path183 = /*#__PURE__*/React.createElement("path", {
    d: "M123.959 236.488L140.122 217.363L151.244 213.286L137.467 231.65L123.959 236.488Z",
    fill: "#FFFAEF"
  })))), _path184 || (_path184 = /*#__PURE__*/React.createElement("path", {
    d: "M165.631 213.307C165.354 214.373 164.66 215.327 163.938 216.236L163.374 216.915L162.763 217.563C162.365 218.003 161.921 218.405 161.486 218.823C159.719 220.455 157.776 221.945 155.741 223.354C151.679 226.179 147.275 228.653 142.723 230.912C140.428 232.022 138.106 233.088 135.728 234.079C133.341 235.048 130.917 235.98 128.437 236.785C125.957 237.605 123.422 238.32 120.832 238.872C119.536 239.14 118.213 239.364 116.89 239.513C115.558 239.654 114.207 239.744 112.875 239.602C115.549 239.58 118.13 239.006 120.628 238.335C123.135 237.664 125.587 236.852 128.002 235.973C132.813 234.199 137.486 232.171 142.001 229.95C146.525 227.737 150.911 225.329 155.056 222.683C157.119 221.357 159.136 219.97 160.996 218.457C161.459 218.077 161.931 217.705 162.365 217.302L163.022 216.706L163.633 216.08C164.419 215.23 165.197 214.351 165.622 213.322L165.631 213.307Z",
    fill: "#FEDE9A"
  }))), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter3_d_13193_55427)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask6_13193_55427",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 203,
    y: 234,
    width: 61,
    height: 35
  }, _path185 || (_path185 = /*#__PURE__*/React.createElement("path", {
    d: "M262.899 262.708C265.23 259.548 254.627 250.999 239.204 243.62C223.78 236.241 209.383 232.82 207.052 235.988C206.497 236.733 204.489 239.468 203.934 240.214C201.602 243.374 212.205 251.923 227.629 259.302C243.053 266.68 257.449 270.101 259.781 266.934C260.336 266.188 262.344 263.453 262.899 262.708Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask6_13193_55427)"
  }, _path186 || (_path186 = /*#__PURE__*/React.createElement("path", {
    d: "M262.899 262.708C265.23 259.548 254.627 250.999 239.204 243.62C223.78 236.242 209.383 232.821 207.052 235.988C206.497 236.734 204.489 239.469 203.934 240.214C201.602 243.374 212.205 251.923 227.629 259.302C243.053 266.681 257.449 270.102 259.781 266.934C260.336 266.189 262.344 263.454 262.899 262.708Z",
    fill: "url(#paint12_linear_13193_55427)"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.68
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path187 || (_path187 = /*#__PURE__*/React.createElement("path", {
    d: "M209.142 234.5L201.279 245.163L201.653 245.341L209.516 234.678L209.142 234.5Z",
    fill: "#C38B2C"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path188 || (_path188 = /*#__PURE__*/React.createElement("path", {
    d: "M209.963 235.048L202.103 245.712L202.477 245.891L210.337 235.227L209.963 235.048Z",
    fill: "#C38B2C"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path189 || (_path189 = /*#__PURE__*/React.createElement("path", {
    d: "M210.819 235.627L202.954 246.289L203.327 246.468L211.192 235.806L210.819 235.627Z",
    fill: "#C38B2C"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path190 || (_path190 = /*#__PURE__*/React.createElement("path", {
    d: "M211.666 236.184L203.801 246.846L204.175 247.025L212.04 236.363L211.666 236.184Z",
    fill: "#C38B2C"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path191 || (_path191 = /*#__PURE__*/React.createElement("path", {
    d: "M212.54 236.739L204.675 247.401L205.049 247.58L212.914 236.918L212.54 236.739Z",
    fill: "#C38B2C"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path192 || (_path192 = /*#__PURE__*/React.createElement("path", {
    d: "M213.401 237.265L205.539 247.928L205.913 248.107L213.775 237.444L213.401 237.265Z",
    fill: "#C38B2C"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path193 || (_path193 = /*#__PURE__*/React.createElement("path", {
    d: "M214.29 237.836L206.43 248.5L206.804 248.679L214.664 238.015L214.29 237.836Z",
    fill: "#C38B2C"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path194 || (_path194 = /*#__PURE__*/React.createElement("path", {
    d: "M215.205 238.393L207.345 249.057L207.719 249.236L215.579 238.572L215.205 238.393Z",
    fill: "#C38B2C"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path195 || (_path195 = /*#__PURE__*/React.createElement("path", {
    d: "M216.152 238.991L208.287 249.653L208.661 249.832L216.526 239.17L216.152 238.991Z",
    fill: "#C38B2C"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path196 || (_path196 = /*#__PURE__*/React.createElement("path", {
    d: "M217.072 239.533L209.21 250.196L209.584 250.375L217.446 239.712L217.072 239.533Z",
    fill: "#C38B2C"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path197 || (_path197 = /*#__PURE__*/React.createElement("path", {
    d: "M218.051 240.123L210.186 250.785L210.56 250.964L218.425 240.302L218.051 240.123Z",
    fill: "#C38B2C"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path198 || (_path198 = /*#__PURE__*/React.createElement("path", {
    d: "M219.016 240.704L211.151 251.366L211.525 251.545L219.39 240.883L219.016 240.704Z",
    fill: "#C38B2C"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path199 || (_path199 = /*#__PURE__*/React.createElement("path", {
    d: "M219.983 241.237L212.121 251.9L212.494 252.079L220.357 241.416L219.983 241.237Z",
    fill: "#C38B2C"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path200 || (_path200 = /*#__PURE__*/React.createElement("path", {
    d: "M220.985 241.818L213.122 252.481L213.496 252.66L221.358 241.997L220.985 241.818Z",
    fill: "#C38B2C"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path201 || (_path201 = /*#__PURE__*/React.createElement("path", {
    d: "M222.015 242.422L214.15 253.084L214.524 253.263L222.389 242.601L222.015 242.422Z",
    fill: "#C38B2C"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path202 || (_path202 = /*#__PURE__*/React.createElement("path", {
    d: "M223.022 242.975L215.162 253.639L215.536 253.818L223.396 243.153L223.022 242.975Z",
    fill: "#C38B2C"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path203 || (_path203 = /*#__PURE__*/React.createElement("path", {
    d: "M224.081 243.575L216.218 254.238L216.592 254.417L224.455 243.754L224.081 243.575Z",
    fill: "#C38B2C"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path204 || (_path204 = /*#__PURE__*/React.createElement("path", {
    d: "M225.143 244.151L217.278 254.813L217.652 254.992L225.517 244.33L225.143 244.151Z",
    fill: "#C38B2C"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path205 || (_path205 = /*#__PURE__*/React.createElement("path", {
    d: "M226.192 244.7L218.332 255.364L218.705 255.543L226.566 244.879L226.192 244.7Z",
    fill: "#C38B2C"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path206 || (_path206 = /*#__PURE__*/React.createElement("path", {
    d: "M227.294 245.301L219.429 255.963L219.803 256.142L227.668 245.48L227.294 245.301Z",
    fill: "#C38B2C"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path207 || (_path207 = /*#__PURE__*/React.createElement("path", {
    d: "M228.402 245.879L220.538 256.541L220.911 256.72L228.776 246.058L228.402 245.879Z",
    fill: "#C38B2C"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path208 || (_path208 = /*#__PURE__*/React.createElement("path", {
    d: "M229.498 246.422L221.636 257.085L222.009 257.264L229.872 246.601L229.498 246.422Z",
    fill: "#C38B2C"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path209 || (_path209 = /*#__PURE__*/React.createElement("path", {
    d: "M230.65 247.036L222.788 257.699L223.162 257.878L231.024 247.215L230.65 247.036Z",
    fill: "#C38B2C"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path210 || (_path210 = /*#__PURE__*/React.createElement("path", {
    d: "M231.769 247.574L223.909 258.238L224.282 258.417L232.143 247.753L231.769 247.574Z",
    fill: "#C38B2C"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path211 || (_path211 = /*#__PURE__*/React.createElement("path", {
    d: "M232.956 248.178L225.091 258.84L225.465 259.019L233.33 248.357L232.956 248.178Z",
    fill: "#C38B2C"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path212 || (_path212 = /*#__PURE__*/React.createElement("path", {
    d: "M234.102 248.718L226.242 259.382L226.616 259.561L234.476 248.897L234.102 248.718Z",
    fill: "#C38B2C"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path213 || (_path213 = /*#__PURE__*/React.createElement("path", {
    d: "M235.284 249.29L227.424 259.954L227.797 260.132L235.658 249.468L235.284 249.29Z",
    fill: "#C38B2C"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path214 || (_path214 = /*#__PURE__*/React.createElement("path", {
    d: "M236.476 249.843L228.616 260.507L228.99 260.686L236.85 250.022L236.476 249.843Z",
    fill: "#C38B2C"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path215 || (_path215 = /*#__PURE__*/React.createElement("path", {
    d: "M237.644 250.385L229.782 261.048L230.156 261.227L238.018 250.564L237.644 250.385Z",
    fill: "#C38B2C"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path216 || (_path216 = /*#__PURE__*/React.createElement("path", {
    d: "M238.82 250.921L230.96 261.585L231.334 261.764L239.194 251.1L238.82 250.921Z",
    fill: "#C38B2C"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path217 || (_path217 = /*#__PURE__*/React.createElement("path", {
    d: "M240.004 251.471L232.139 262.133L232.513 262.312L240.378 251.65L240.004 251.471Z",
    fill: "#C38B2C"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path218 || (_path218 = /*#__PURE__*/React.createElement("path", {
    d: "M241.162 251.991L233.297 262.653L233.671 262.832L241.536 252.17L241.162 251.991Z",
    fill: "#C38B2C"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path219 || (_path219 = /*#__PURE__*/React.createElement("path", {
    d: "M242.316 252.491L234.453 263.154L234.827 263.333L242.69 252.67L242.316 252.491Z",
    fill: "#C38B2C"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path220 || (_path220 = /*#__PURE__*/React.createElement("path", {
    d: "M243.441 252.952L235.578 263.615L235.952 263.794L243.815 253.131L243.441 252.952Z",
    fill: "#C38B2C"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path221 || (_path221 = /*#__PURE__*/React.createElement("path", {
    d: "M244.601 253.461L236.736 264.123L237.11 264.302L244.975 253.64L244.601 253.461Z",
    fill: "#C38B2C"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path222 || (_path222 = /*#__PURE__*/React.createElement("path", {
    d: "M245.739 253.926L237.874 264.588L238.248 264.767L246.113 254.105L245.739 253.926Z",
    fill: "#C38B2C"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path223 || (_path223 = /*#__PURE__*/React.createElement("path", {
    d: "M246.862 254.395L238.999 265.058L239.373 265.237L247.236 254.574L246.862 254.395Z",
    fill: "#C38B2C"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path224 || (_path224 = /*#__PURE__*/React.createElement("path", {
    d: "M247.957 254.809L240.095 265.472L240.469 265.651L248.331 254.988L247.957 254.809Z",
    fill: "#C38B2C"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path225 || (_path225 = /*#__PURE__*/React.createElement("path", {
    d: "M249.058 255.249L241.196 265.912L241.57 266.091L249.432 255.428L249.058 255.249Z",
    fill: "#C38B2C"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path226 || (_path226 = /*#__PURE__*/React.createElement("path", {
    d: "M250.162 255.69L242.302 266.354L242.676 266.533L250.536 255.869L250.162 255.69Z",
    fill: "#C38B2C"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path227 || (_path227 = /*#__PURE__*/React.createElement("path", {
    d: "M251.252 256.094L243.389 266.757L243.763 266.936L251.625 256.273L251.252 256.094Z",
    fill: "#C38B2C"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path228 || (_path228 = /*#__PURE__*/React.createElement("path", {
    d: "M252.361 256.537L244.496 267.199L244.87 267.378L252.735 256.716L252.361 256.537Z",
    fill: "#C38B2C"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path229 || (_path229 = /*#__PURE__*/React.createElement("path", {
    d: "M253.432 256.946L245.57 267.609L245.944 267.788L253.806 257.125L253.432 256.946Z",
    fill: "#C38B2C"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path230 || (_path230 = /*#__PURE__*/React.createElement("path", {
    d: "M254.499 257.343L246.637 268.006L247.01 268.185L254.873 257.522L254.499 257.343Z",
    fill: "#C38B2C"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path231 || (_path231 = /*#__PURE__*/React.createElement("path", {
    d: "M255.553 257.723L247.689 268.385L248.062 268.564L255.927 257.902L255.553 257.723Z",
    fill: "#C38B2C"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path232 || (_path232 = /*#__PURE__*/React.createElement("path", {
    d: "M256.583 258.055L248.721 268.718L249.095 268.897L256.957 258.234L256.583 258.055Z",
    fill: "#C38B2C"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path233 || (_path233 = /*#__PURE__*/React.createElement("path", {
    d: "M257.624 258.425L249.763 269.089L250.137 269.268L257.997 258.604L257.624 258.425Z",
    fill: "#C38B2C"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path234 || (_path234 = /*#__PURE__*/React.createElement("path", {
    d: "M258.669 258.81L250.806 269.473L251.18 269.652L259.043 258.989L258.669 258.81Z",
    fill: "#C38B2C"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path235 || (_path235 = /*#__PURE__*/React.createElement("path", {
    d: "M259.665 259.126L251.802 269.789L252.176 269.968L260.038 259.305L259.665 259.126Z",
    fill: "#C38B2C"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path236 || (_path236 = /*#__PURE__*/React.createElement("path", {
    d: "M260.676 259.463L252.814 270.126L253.188 270.305L261.05 259.642L260.676 259.463Z",
    fill: "#C38B2C"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path237 || (_path237 = /*#__PURE__*/React.createElement("path", {
    d: "M261.694 259.819L253.829 270.481L254.202 270.66L262.067 259.998L261.694 259.819Z",
    fill: "#C38B2C"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path238 || (_path238 = /*#__PURE__*/React.createElement("path", {
    d: "M262.675 260.146L254.811 270.808L255.184 270.987L263.049 260.325L262.675 260.146Z",
    fill: "#C38B2C"
  }))))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    },
    opacity: 0.23
  }, _path239 || (_path239 = /*#__PURE__*/React.createElement("path", {
    d: "M233.68 241.131C228.915 239.104 224.381 237.501 220.44 236.42L210.808 249.479C213.871 251.744 217.785 254.189 222.272 256.589L233.68 241.131Z",
    fill: "#FFFAEF"
  }))), _path240 || (_path240 = /*#__PURE__*/React.createElement("path", {
    d: "M262.899 262.708C260.567 265.868 246.171 262.455 230.747 255.076C215.323 247.697 204.711 239.148 207.052 235.988C209.383 232.828 223.78 236.241 239.204 243.62C254.627 250.999 265.24 259.548 262.899 262.708Z",
    fill: "url(#paint13_linear_13193_55427)"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    },
    opacity: 0.33
  }, _path241 || (_path241 = /*#__PURE__*/React.createElement("path", {
    d: "M227.666 252.192C230.951 252.385 234.235 252.631 237.52 252.788C240.795 252.944 244.061 253.049 247.337 253.146C250.214 253.228 253.082 253.31 255.96 253.399C253.434 251.528 250.344 249.553 246.819 247.571C245.098 247.459 243.367 247.354 241.646 247.243C237.067 246.952 232.496 246.646 227.925 246.289C223.382 245.931 218.839 245.528 214.297 245.171C214.121 245.156 213.945 245.141 213.769 245.133C216.721 247.332 220.486 249.702 224.807 252.042C225.76 252.087 226.713 252.132 227.657 252.192H227.666Z",
    fill: "#FFFAEF"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask7_13193_55427",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 213,
    y: 237,
    width: 45,
    height: 24
  }, _path242 || (_path242 = /*#__PURE__*/React.createElement("path", {
    d: "M257.033 259.28C255.404 261.486 244.357 258.624 232.366 252.885C220.375 247.146 211.965 240.706 213.593 238.5C215.222 236.294 226.269 239.156 238.26 244.895C250.251 250.634 258.661 257.074 257.033 259.28Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask7_13193_55427)"
  }, _path243 || (_path243 = /*#__PURE__*/React.createElement("path", {
    d: "M257.033 259.28C255.404 261.486 244.357 258.624 232.366 252.885C220.375 247.146 211.965 240.706 213.593 238.5C215.222 236.294 226.269 239.156 238.26 244.895C250.251 250.634 258.661 257.074 257.033 259.28Z",
    fill: "url(#paint14_linear_13193_55427)"
  })), _path244 || (_path244 = /*#__PURE__*/React.createElement("path", {
    d: "M256.172 261.173C254.544 263.379 243.497 260.517 231.506 254.778C219.515 249.039 211.104 242.599 212.733 240.393C214.361 238.187 225.408 241.049 237.399 246.788C249.39 252.527 257.801 258.967 256.172 261.173Z",
    fill: "url(#paint15_linear_13193_55427)"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    },
    opacity: 0.11
  }, _path245 || (_path245 = /*#__PURE__*/React.createElement("path", {
    d: "M215.878 245.074L244.44 247.526L254.155 253.496L227.546 252.385L215.878 245.074Z",
    fill: "#FFFAEF"
  })))), _path246 || (_path246 = /*#__PURE__*/React.createElement("path", {
    d: "M260.919 263.729C259.624 264.035 258.245 263.997 256.913 263.915L255.904 263.833L254.905 263.707C254.239 263.632 253.582 263.505 252.925 263.401C250.307 262.917 247.753 262.238 245.255 261.456C240.249 259.906 235.457 257.953 230.84 255.776C228.536 254.673 226.278 253.526 224.067 252.303C221.874 251.066 219.718 249.784 217.664 248.405C215.601 247.034 213.621 245.565 211.789 243.985C210.882 243.188 210.022 242.361 209.226 241.488C208.449 240.609 207.709 239.692 207.228 238.686C208.514 240.572 210.355 242.137 212.28 243.598C214.195 245.066 216.249 246.415 218.349 247.712C222.559 250.298 226.991 252.646 231.552 254.807C236.114 256.976 240.814 258.951 245.671 260.651C248.105 261.486 250.566 262.268 253.101 262.872C253.739 263.021 254.368 263.185 255.016 263.297L255.978 263.483L256.95 263.625C258.254 263.781 259.587 263.915 260.91 263.736L260.919 263.729Z",
    fill: "#FEDE9A"
  }))), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter4_d_13193_55427)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask8_13193_55427",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 20,
    y: 259,
    width: 57,
    height: 35
  }, _path247 || (_path247 = /*#__PURE__*/React.createElement("path", {
    d: "M76.023 287.772C78.7691 284.211 69.5178 275.35 55.3609 267.974C41.204 260.597 27.4981 257.497 24.7521 261.058C24.1097 261.895 21.733 264.969 21.0822 265.804C18.3362 269.365 27.5874 278.226 41.7443 285.602C55.9012 292.979 69.6071 296.079 72.3532 292.518C72.9955 291.681 75.3722 288.607 76.023 287.772Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask8_13193_55427)"
  }, _path248 || (_path248 = /*#__PURE__*/React.createElement("path", {
    d: "M76.0099 287.767C78.7584 284.203 69.5159 275.341 55.3672 267.967C41.2186 260.592 27.5173 257.496 24.7687 261.06C24.1258 261.897 21.7468 264.974 21.0954 265.809C18.3469 269.373 27.5894 278.235 41.7381 285.61C55.8867 292.984 69.5881 296.08 72.3366 292.517C72.9795 291.679 75.3585 288.602 76.0099 287.767Z",
    fill: "url(#paint16_linear_13193_55427)"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.68
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path249 || (_path249 = /*#__PURE__*/React.createElement("path", {
    d: "M24.8225 259.409L16.6008 269.957L16.9041 270.113L25.1257 259.565L24.8225 259.409Z",
    fill: "#C38B2C"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path250 || (_path250 = /*#__PURE__*/React.createElement("path", {
    d: "M25.6361 259.973L17.4144 270.521L17.7177 270.677L25.9393 260.129L25.6361 259.973Z",
    fill: "#C38B2C"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path251 || (_path251 = /*#__PURE__*/React.createElement("path", {
    d: "M26.4608 260.54L18.2391 271.087L18.5424 271.244L26.764 260.696L26.4608 260.54Z",
    fill: "#C38B2C"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path252 || (_path252 = /*#__PURE__*/React.createElement("path", {
    d: "M27.2912 261.124L19.0695 271.672L19.3728 271.829L27.5944 261.281L27.2912 261.124Z",
    fill: "#C38B2C"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path253 || (_path253 = /*#__PURE__*/React.createElement("path", {
    d: "M28.1428 261.673L19.9211 272.221L20.2244 272.378L28.446 261.83L28.1428 261.673Z",
    fill: "#C38B2C"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path254 || (_path254 = /*#__PURE__*/React.createElement("path", {
    d: "M29.014 262.253L20.7924 272.801L21.0956 272.957L29.3173 262.41L29.014 262.253Z",
    fill: "#C38B2C"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path255 || (_path255 = /*#__PURE__*/React.createElement("path", {
    d: "M29.8963 262.835L21.6747 273.383L21.9779 273.54L30.1996 262.992L29.8963 262.835Z",
    fill: "#C38B2C"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path256 || (_path256 = /*#__PURE__*/React.createElement("path", {
    d: "M30.7843 263.418L22.5626 273.966L22.8659 274.123L31.0875 263.575L30.7843 263.418Z",
    fill: "#C38B2C"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path257 || (_path257 = /*#__PURE__*/React.createElement("path", {
    d: "M31.6985 263.994L23.4768 274.542L23.78 274.699L32.0017 264.151L31.6985 263.994Z",
    fill: "#C38B2C"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path258 || (_path258 = /*#__PURE__*/React.createElement("path", {
    d: "M32.6196 264.586L24.3979 275.134L24.7012 275.29L32.9228 264.743L32.6196 264.586Z",
    fill: "#C38B2C"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path259 || (_path259 = /*#__PURE__*/React.createElement("path", {
    d: "M33.5593 265.167L25.3376 275.714L25.6409 275.871L33.8625 265.323L33.5593 265.167Z",
    fill: "#C38B2C"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path260 || (_path260 = /*#__PURE__*/React.createElement("path", {
    d: "M34.5096 265.758L26.288 276.306L26.5912 276.463L34.8129 265.915L34.5096 265.758Z",
    fill: "#C38B2C"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path261 || (_path261 = /*#__PURE__*/React.createElement("path", {
    d: "M35.4746 266.344L27.2529 276.892L27.5562 277.049L35.7778 266.501L35.4746 266.344Z",
    fill: "#C38B2C"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path262 || (_path262 = /*#__PURE__*/React.createElement("path", {
    d: "M36.4649 266.947L28.2432 277.495L28.5465 277.651L36.7681 267.104L36.4649 266.947Z",
    fill: "#C38B2C"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path263 || (_path263 = /*#__PURE__*/React.createElement("path", {
    d: "M37.4516 267.546L29.2299 278.094L29.5332 278.251L37.7548 267.703L37.4516 267.546Z",
    fill: "#C38B2C"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path264 || (_path264 = /*#__PURE__*/React.createElement("path", {
    d: "M38.4581 268.134L30.2365 278.682L30.5397 278.839L38.7613 268.291L38.4581 268.134Z",
    fill: "#C38B2C"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path265 || (_path265 = /*#__PURE__*/React.createElement("path", {
    d: "M39.495 268.723L31.2733 279.271L31.5766 279.428L39.7982 268.88L39.495 268.723Z",
    fill: "#C38B2C"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path266 || (_path266 = /*#__PURE__*/React.createElement("path", {
    d: "M40.5347 269.32L32.313 279.868L32.6163 280.024L40.8379 269.477L40.5347 269.32Z",
    fill: "#C38B2C"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path267 || (_path267 = /*#__PURE__*/React.createElement("path", {
    d: "M41.5892 269.911L33.3675 280.458L33.6707 280.615L41.8924 270.067L41.5892 269.911Z",
    fill: "#C38B2C"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path268 || (_path268 = /*#__PURE__*/React.createElement("path", {
    d: "M42.6542 270.512L34.4326 281.06L34.7358 281.217L42.9575 270.669L42.6542 270.512Z",
    fill: "#C38B2C"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path269 || (_path269 = /*#__PURE__*/React.createElement("path", {
    d: "M43.7468 271.105L35.5251 281.653L35.8284 281.81L44.05 271.262L43.7468 271.105Z",
    fill: "#C38B2C"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path270 || (_path270 = /*#__PURE__*/React.createElement("path", {
    d: "M44.8517 271.699L36.63 282.247L36.9332 282.404L45.1549 271.856L44.8517 271.699Z",
    fill: "#C38B2C"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path271 || (_path271 = /*#__PURE__*/React.createElement("path", {
    d: "M45.9594 272.293L37.7377 282.84L38.041 282.997L46.2626 272.449L45.9594 272.293Z",
    fill: "#C38B2C"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path272 || (_path272 = /*#__PURE__*/React.createElement("path", {
    d: "M47.0895 272.892L38.8679 283.439L39.1711 283.596L47.3928 273.048L47.0895 272.892Z",
    fill: "#C38B2C"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path273 || (_path273 = /*#__PURE__*/React.createElement("path", {
    d: "M48.2334 273.487L40.0117 284.035L40.315 284.191L48.5366 273.644L48.2334 273.487Z",
    fill: "#C38B2C"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path274 || (_path274 = /*#__PURE__*/React.createElement("path", {
    d: "M49.3809 274.087L41.1592 284.635L41.4625 284.791L49.6841 274.244L49.3809 274.087Z",
    fill: "#C38B2C"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path275 || (_path275 = /*#__PURE__*/React.createElement("path", {
    d: "M50.5594 274.664L42.3377 285.211L42.6409 285.368L50.8626 274.82L50.5594 274.664Z",
    fill: "#C38B2C"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path276 || (_path276 = /*#__PURE__*/React.createElement("path", {
    d: "M51.7247 275.243L43.5031 285.791L43.8063 285.948L52.028 275.4L51.7247 275.243Z",
    fill: "#C38B2C"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path277 || (_path277 = /*#__PURE__*/React.createElement("path", {
    d: "M52.889 275.802L44.6673 286.35L44.9705 286.507L53.1922 275.959L52.889 275.802Z",
    fill: "#C38B2C"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path278 || (_path278 = /*#__PURE__*/React.createElement("path", {
    d: "M54.0484 276.36L45.8267 286.908L46.13 287.064L54.3516 276.517L54.0484 276.36Z",
    fill: "#C38B2C"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path279 || (_path279 = /*#__PURE__*/React.createElement("path", {
    d: "M55.1885 276.914L46.9668 287.462L47.27 287.619L55.4917 277.071L55.1885 276.914Z",
    fill: "#C38B2C"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path280 || (_path280 = /*#__PURE__*/React.createElement("path", {
    d: "M56.3369 277.439L48.1152 287.987L48.4185 288.144L56.6401 277.596L56.3369 277.439Z",
    fill: "#C38B2C"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path281 || (_path281 = /*#__PURE__*/React.createElement("path", {
    d: "M57.4842 277.961L49.2625 288.509L49.5657 288.666L57.7874 278.118L57.4842 277.961Z",
    fill: "#C38B2C"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path282 || (_path282 = /*#__PURE__*/React.createElement("path", {
    d: "M58.6136 278.475L50.3919 289.022L50.6951 289.179L58.9168 278.631L58.6136 278.475Z",
    fill: "#C38B2C"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path283 || (_path283 = /*#__PURE__*/React.createElement("path", {
    d: "M59.7383 278.969L51.5166 289.517L51.8198 289.674L60.0415 279.126L59.7383 278.969Z",
    fill: "#C38B2C"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path284 || (_path284 = /*#__PURE__*/React.createElement("path", {
    d: "M60.8478 279.465L52.6262 290.013L52.9294 290.17L61.1511 279.622L60.8478 279.465Z",
    fill: "#C38B2C"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path285 || (_path285 = /*#__PURE__*/React.createElement("path", {
    d: "M61.9585 279.959L53.7369 290.507L54.0401 290.664L62.2618 280.116L61.9585 279.959Z",
    fill: "#C38B2C"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path286 || (_path286 = /*#__PURE__*/React.createElement("path", {
    d: "M63.0676 280.42L54.8459 290.968L55.1492 291.124L63.3708 280.577L63.0676 280.42Z",
    fill: "#C38B2C"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path287 || (_path287 = /*#__PURE__*/React.createElement("path", {
    d: "M64.1641 280.882L55.9424 291.43L56.2457 291.587L64.4673 281.039L64.1641 280.882Z",
    fill: "#C38B2C"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path288 || (_path288 = /*#__PURE__*/React.createElement("path", {
    d: "M65.2502 281.323L57.0285 291.871L57.3317 292.027L65.5534 281.479L65.2502 281.323Z",
    fill: "#C38B2C"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path289 || (_path289 = /*#__PURE__*/React.createElement("path", {
    d: "M66.3267 281.768L58.105 292.316L58.4083 292.473L66.6299 281.925L66.3267 281.768Z",
    fill: "#C38B2C"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path290 || (_path290 = /*#__PURE__*/React.createElement("path", {
    d: "M67.4098 282.197L59.1882 292.745L59.4914 292.902L67.7131 282.354L67.4098 282.197Z",
    fill: "#C38B2C"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path291 || (_path291 = /*#__PURE__*/React.createElement("path", {
    d: "M68.4639 282.614L60.2422 293.162L60.5454 293.319L68.7671 282.771L68.4639 282.614Z",
    fill: "#C38B2C"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path292 || (_path292 = /*#__PURE__*/React.createElement("path", {
    d: "M69.5183 283.023L61.2966 293.571L61.5999 293.728L69.8215 283.18L69.5183 283.023Z",
    fill: "#C38B2C"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path293 || (_path293 = /*#__PURE__*/React.createElement("path", {
    d: "M70.5716 283.43L62.3499 293.978L62.6531 294.135L70.8748 283.587L70.5716 283.43Z",
    fill: "#C38B2C"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path294 || (_path294 = /*#__PURE__*/React.createElement("path", {
    d: "M71.6114 283.816L63.3897 294.364L63.6929 294.52L71.9146 283.973L71.6114 283.816Z",
    fill: "#C38B2C"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path295 || (_path295 = /*#__PURE__*/React.createElement("path", {
    d: "M72.6362 284.204L64.4146 294.751L64.7178 294.908L72.9395 284.36L72.6362 284.204Z",
    fill: "#C38B2C"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path296 || (_path296 = /*#__PURE__*/React.createElement("path", {
    d: "M73.6561 284.571L65.4344 295.119L65.7377 295.276L73.9593 284.728L73.6561 284.571Z",
    fill: "#C38B2C"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path297 || (_path297 = /*#__PURE__*/React.createElement("path", {
    d: "M74.6613 284.941L66.4396 295.489L66.7429 295.645L74.9645 285.098L74.6613 284.941Z",
    fill: "#C38B2C"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path298 || (_path298 = /*#__PURE__*/React.createElement("path", {
    d: "M75.6552 285.308L67.4335 295.856L67.7368 296.013L75.9584 285.465L75.6552 285.308Z",
    fill: "#C38B2C"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path299 || (_path299 = /*#__PURE__*/React.createElement("path", {
    d: "M76.6419 285.637L68.4202 296.185L68.7235 296.342L76.9451 285.794L76.6419 285.637Z",
    fill: "#C38B2C"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path300 || (_path300 = /*#__PURE__*/React.createElement("path", {
    d: "M77.6191 285.98L69.3974 296.527L69.7006 296.684L77.9223 286.136L77.6191 285.98Z",
    fill: "#C38B2C"
  }))))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    },
    opacity: 0.23
  }, _path301 || (_path301 = /*#__PURE__*/React.createElement("path", {
    d: "M48.9874 265.702C44.7109 263.779 40.601 262.284 36.9931 261.31L26.3079 275.059C28.9369 277.29 32.3672 279.659 36.338 281.981L48.9842 265.709L48.9874 265.702Z",
    fill: "#FFFAEF"
  }))), _path302 || (_path302 = /*#__PURE__*/React.createElement("path", {
    d: "M77.0372 287.961C79.8299 284.507 70.064 275.772 55.2244 268.451C40.3847 261.129 26.0909 257.994 23.2982 261.448C20.5055 264.901 30.2714 273.636 45.111 280.958C59.9507 288.279 74.2445 291.415 77.0372 287.961Z",
    fill: "url(#paint17_linear_13193_55427)"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    },
    opacity: 0.33
  }, _path303 || (_path303 = /*#__PURE__*/React.createElement("path", {
    d: "M42.5146 278.12C45.7786 278.217 49.0363 278.374 52.3085 278.428C55.5634 278.478 58.8299 278.478 62.0911 278.467C64.9542 278.458 67.8293 278.443 70.6924 278.433C68.3981 276.442 65.5453 274.336 62.2755 272.255C60.5664 272.198 58.8486 272.14 57.1429 272.076C52.5973 271.919 48.0585 271.747 43.526 271.513C39.0196 271.286 34.5281 271 30.0163 270.762C29.8414 270.75 29.6631 270.746 29.4881 270.735C32.172 273.086 35.6433 275.593 39.6767 278.046C40.6272 278.06 41.5656 278.08 42.5093 278.11L42.5146 278.12Z",
    fill: "#FFFAEF"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask9_13193_55427",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 30,
    y: 262,
    width: 41,
    height: 24
  }, _path304 || (_path304 = /*#__PURE__*/React.createElement("path", {
    d: "M70.6721 284.834C68.7532 287.343 58.1723 284.645 47.037 278.804C35.9104 272.965 28.4471 266.184 30.366 263.674C32.2848 261.164 42.8658 263.862 54.001 269.703C65.1277 275.543 72.5909 282.324 70.6721 284.834Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask9_13193_55427)"
  }, _path305 || (_path305 = /*#__PURE__*/React.createElement("path", {
    d: "M70.6513 284.831C68.7286 287.346 58.1539 284.653 47.0302 278.813C35.9151 272.975 28.4643 266.192 30.3869 263.677C32.3096 261.163 42.8842 263.855 54.008 269.695C65.1231 275.533 72.5739 282.317 70.6513 284.831Z",
    fill: "url(#paint18_linear_13193_55427)"
  })), _path306 || (_path306 = /*#__PURE__*/React.createElement("path", {
    d: "M69.7421 286.712C67.8194 289.227 57.2448 286.534 46.121 280.694C35.0059 274.856 27.5551 268.073 29.4777 265.558C31.4004 263.043 41.9751 265.736 53.0988 271.576C64.214 277.414 71.6647 284.197 69.7421 286.712Z",
    fill: "url(#paint19_linear_13193_55427)"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    },
    opacity: 0.11
  }, _path307 || (_path307 = /*#__PURE__*/React.createElement("path", {
    d: "M31.6929 270.659L59.9417 272.171L68.8278 278.502L42.3451 278.434L31.6929 270.659Z",
    fill: "#FFFAEF"
  })))), _path308 || (_path308 = /*#__PURE__*/React.createElement("path", {
    d: "M74.9092 289.431C73.5852 289.786 72.2106 289.773 70.893 289.714L69.8914 289.649L68.912 289.53C68.2527 289.466 67.6099 289.338 66.9664 289.235C64.397 288.765 61.9097 288.093 59.4815 287.298C54.6244 285.734 50.0232 283.725 45.6132 281.48C43.4205 280.339 41.2672 279.147 39.1749 277.876C37.1007 276.583 35.0684 275.257 33.1453 273.803C31.2158 272.364 29.3709 270.834 27.6969 269.164C26.8674 268.322 26.0798 267.447 25.3698 266.522C24.6717 265.591 24.0273 264.621 23.6379 263.539C24.7461 265.548 26.4414 267.189 28.2277 268.723C30.002 270.262 31.9291 271.684 33.9052 273.031C37.866 275.727 42.0711 278.173 46.4288 280.406C50.7833 282.648 55.2871 284.685 59.9845 286.409C62.332 287.262 64.7253 288.049 67.203 288.651C67.822 288.791 68.4371 288.964 69.0688 289.072L70.0143 289.252L70.9787 289.385C72.2648 289.522 73.5833 289.65 74.9242 289.417L74.9092 289.431Z",
    fill: "#FEDE9A"
  }))), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter5_d_13193_55427)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask10_13193_55427",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 170,
    y: 84,
    width: 56,
    height: 33
  }, _path309 || (_path309 = /*#__PURE__*/React.createElement("path", {
    d: "M225.44 111.41C227.699 108.479 217.939 100.3 203.639 93.1521C189.339 86.0043 175.91 82.5825 173.651 85.5199C173.119 86.2092 171.161 88.7429 170.629 89.4385C168.37 92.3696 178.13 100.548 192.43 107.696C206.73 114.844 220.159 118.266 222.418 115.328C222.95 114.639 224.908 112.105 225.44 111.41Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask10_13193_55427)"
  }, _path310 || (_path310 = /*#__PURE__*/React.createElement("path", {
    d: "M225.44 111.41C227.699 108.479 217.939 100.3 203.639 93.1521C189.339 86.0043 175.909 82.5825 173.651 85.5199C173.119 86.2092 171.161 88.7429 170.629 89.4385C168.37 92.3696 178.13 100.548 192.43 107.696C206.73 114.844 220.159 118.266 222.418 115.328C222.95 114.639 224.908 112.105 225.44 111.41Z",
    fill: "url(#paint20_linear_13193_55427)"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.68
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path311 || (_path311 = /*#__PURE__*/React.createElement("path", {
    d: "M175.632 84.1567L168.015 94.0454L168.362 94.2189L175.98 84.3303L175.632 84.1567Z",
    fill: "#C38B2C"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path312 || (_path312 = /*#__PURE__*/React.createElement("path", {
    d: "M176.399 84.6827L168.782 94.5713L169.129 94.7448L176.746 84.8562L176.399 84.6827Z",
    fill: "#C38B2C"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path313 || (_path313 = /*#__PURE__*/React.createElement("path", {
    d: "M177.19 85.2296L169.571 95.1172L169.918 95.2908L177.537 85.4032L177.19 85.2296Z",
    fill: "#C38B2C"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path314 || (_path314 = /*#__PURE__*/React.createElement("path", {
    d: "M177.983 85.7619L170.364 95.6494L170.711 95.823L178.331 85.9354L177.983 85.7619Z",
    fill: "#C38B2C"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path315 || (_path315 = /*#__PURE__*/React.createElement("path", {
    d: "M178.756 86.2818L171.139 96.1704L171.486 96.3439L179.103 86.4553L178.756 86.2818Z",
    fill: "#C38B2C"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path316 || (_path316 = /*#__PURE__*/React.createElement("path", {
    d: "M179.593 86.8322L171.974 96.7197L172.321 96.8933L179.941 87.0058L179.593 86.8322Z",
    fill: "#C38B2C"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path317 || (_path317 = /*#__PURE__*/React.createElement("path", {
    d: "M180.425 87.3727L172.806 97.2603L173.153 97.4338L180.772 87.5462L180.425 87.3727Z",
    fill: "#C38B2C"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path318 || (_path318 = /*#__PURE__*/React.createElement("path", {
    d: "M181.267 87.9181L173.648 97.8057L173.995 97.9792L181.615 88.0917L181.267 87.9181Z",
    fill: "#C38B2C"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path319 || (_path319 = /*#__PURE__*/React.createElement("path", {
    d: "M182.098 88.4346L174.481 98.3232L174.828 98.4968L182.445 88.6081L182.098 88.4346Z",
    fill: "#C38B2C"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path320 || (_path320 = /*#__PURE__*/React.createElement("path", {
    d: "M182.966 88.9922L175.349 98.8809L175.696 99.0544L183.314 89.1658L182.966 88.9922Z",
    fill: "#C38B2C"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path321 || (_path321 = /*#__PURE__*/React.createElement("path", {
    d: "M183.848 89.5367L176.231 99.4253L176.578 99.5988L184.196 89.7102L183.848 89.5367Z",
    fill: "#C38B2C"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path322 || (_path322 = /*#__PURE__*/React.createElement("path", {
    d: "M184.749 90.0918L177.132 99.9805L177.479 100.154L185.096 90.2654L184.749 90.0918Z",
    fill: "#C38B2C"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path323 || (_path323 = /*#__PURE__*/React.createElement("path", {
    d: "M185.651 90.6392L178.034 100.528L178.381 100.701L185.998 90.8127L185.651 90.6392Z",
    fill: "#C38B2C"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path324 || (_path324 = /*#__PURE__*/React.createElement("path", {
    d: "M186.581 91.1949L178.964 101.083L179.311 101.257L186.929 91.3684L186.581 91.1949Z",
    fill: "#C38B2C"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path325 || (_path325 = /*#__PURE__*/React.createElement("path", {
    d: "M187.517 91.7481L179.9 101.637L180.248 101.81L187.865 91.9216L187.517 91.7481Z",
    fill: "#C38B2C"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path326 || (_path326 = /*#__PURE__*/React.createElement("path", {
    d: "M188.466 92.2984L180.849 102.187L181.196 102.361L188.813 92.4719L188.466 92.2984Z",
    fill: "#C38B2C"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path327 || (_path327 = /*#__PURE__*/React.createElement("path", {
    d: "M189.454 92.8805L181.835 102.768L182.182 102.942L189.801 93.0541L189.454 92.8805Z",
    fill: "#C38B2C"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path328 || (_path328 = /*#__PURE__*/React.createElement("path", {
    d: "M190.408 93.4117L182.791 103.3L183.138 103.474L190.755 93.5852L190.408 93.4117Z",
    fill: "#C38B2C"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path329 || (_path329 = /*#__PURE__*/React.createElement("path", {
    d: "M191.402 93.9747L183.785 103.863L184.132 104.037L191.749 94.1482L191.402 93.9747Z",
    fill: "#C38B2C"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path330 || (_path330 = /*#__PURE__*/React.createElement("path", {
    d: "M192.431 94.5504L184.812 104.438L185.159 104.612L192.778 94.724L192.431 94.5504Z",
    fill: "#C38B2C"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path331 || (_path331 = /*#__PURE__*/React.createElement("path", {
    d: "M193.428 95.0855L185.811 104.974L186.158 105.148L193.775 95.259L193.428 95.0855Z",
    fill: "#C38B2C"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path332 || (_path332 = /*#__PURE__*/React.createElement("path", {
    d: "M194.462 95.6421L186.845 105.531L187.192 105.704L194.809 95.8157L194.462 95.6421Z",
    fill: "#C38B2C"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path333 || (_path333 = /*#__PURE__*/React.createElement("path", {
    d: "M195.528 96.2194L187.908 106.107L188.255 106.281L195.875 96.393L195.528 96.2194Z",
    fill: "#C38B2C"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path334 || (_path334 = /*#__PURE__*/React.createElement("path", {
    d: "M196.571 96.751L188.954 106.64L189.301 106.813L196.918 96.9246L196.571 96.751Z",
    fill: "#C38B2C"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path335 || (_path335 = /*#__PURE__*/React.createElement("path", {
    d: "M197.646 97.3032L190.029 107.192L190.376 107.365L197.993 97.4768L197.646 97.3032Z",
    fill: "#C38B2C"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path336 || (_path336 = /*#__PURE__*/React.createElement("path", {
    d: "M198.733 97.8565L191.115 107.745L191.463 107.919L199.08 98.03L198.733 97.8565Z",
    fill: "#C38B2C"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path337 || (_path337 = /*#__PURE__*/React.createElement("path", {
    d: "M199.843 98.4058L192.226 108.294L192.573 108.468L200.19 98.5793L199.843 98.4058Z",
    fill: "#C38B2C"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path338 || (_path338 = /*#__PURE__*/React.createElement("path", {
    d: "M200.929 98.9439L193.312 108.833L193.659 109.006L201.276 99.1174L200.929 98.9439Z",
    fill: "#C38B2C"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path339 || (_path339 = /*#__PURE__*/React.createElement("path", {
    d: "M202.02 99.476L194.405 109.366L194.752 109.539L202.367 99.6495L202.02 99.476Z",
    fill: "#C38B2C"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path340 || (_path340 = /*#__PURE__*/React.createElement("path", {
    d: "M203.129 100.021L195.509 109.908L195.857 110.082L203.476 100.194L203.129 100.021Z",
    fill: "#C38B2C"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path341 || (_path341 = /*#__PURE__*/React.createElement("path", {
    d: "M204.193 100.502L196.576 110.391L196.923 110.565L204.54 100.676L204.193 100.502Z",
    fill: "#C38B2C"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path342 || (_path342 = /*#__PURE__*/React.createElement("path", {
    d: "M205.266 101L197.649 110.888L197.996 111.062L205.613 101.173L205.266 101Z",
    fill: "#C38B2C"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path343 || (_path343 = /*#__PURE__*/React.createElement("path", {
    d: "M206.341 101.487L198.724 111.375L199.071 111.549L206.688 101.66L206.341 101.487Z",
    fill: "#C38B2C"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path344 || (_path344 = /*#__PURE__*/React.createElement("path", {
    d: "M207.4 101.964L199.783 111.853L200.13 112.027L207.747 102.138L207.4 101.964Z",
    fill: "#C38B2C"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path345 || (_path345 = /*#__PURE__*/React.createElement("path", {
    d: "M208.486 102.453L200.866 112.34L201.213 112.514L208.833 102.626L208.486 102.453Z",
    fill: "#C38B2C"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path346 || (_path346 = /*#__PURE__*/React.createElement("path", {
    d: "M209.531 102.915L201.912 112.803L202.259 112.976L209.878 103.089L209.531 102.915Z",
    fill: "#C38B2C"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path347 || (_path347 = /*#__PURE__*/React.createElement("path", {
    d: "M210.555 103.34L202.938 113.229L203.285 113.402L210.902 103.513L210.555 103.34Z",
    fill: "#C38B2C"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path348 || (_path348 = /*#__PURE__*/React.createElement("path", {
    d: "M211.613 103.8L203.994 113.688L204.341 113.861L211.96 103.974L211.613 103.8Z",
    fill: "#C38B2C"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path349 || (_path349 = /*#__PURE__*/React.createElement("path", {
    d: "M212.616 104.201L204.999 114.089L205.346 114.263L212.963 104.374L212.616 104.201Z",
    fill: "#C38B2C"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path350 || (_path350 = /*#__PURE__*/React.createElement("path", {
    d: "M213.636 104.62L206.021 114.509L206.368 114.683L213.983 104.793L213.636 104.62Z",
    fill: "#C38B2C"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path351 || (_path351 = /*#__PURE__*/React.createElement("path", {
    d: "M214.652 105.035L207.035 114.923L207.382 115.097L214.999 105.208L214.652 105.035Z",
    fill: "#C38B2C"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path352 || (_path352 = /*#__PURE__*/React.createElement("path", {
    d: "M215.689 105.458L208.069 115.345L208.417 115.519L216.036 105.631L215.689 105.458Z",
    fill: "#C38B2C"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path353 || (_path353 = /*#__PURE__*/React.createElement("path", {
    d: "M216.663 105.833L209.046 115.722L209.393 115.895L217.01 106.007L216.663 105.833Z",
    fill: "#C38B2C"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path354 || (_path354 = /*#__PURE__*/React.createElement("path", {
    d: "M217.649 106.209L210.031 116.098L210.379 116.271L217.996 106.383L217.649 106.209Z",
    fill: "#C38B2C"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path355 || (_path355 = /*#__PURE__*/React.createElement("path", {
    d: "M218.634 106.589L211.017 116.478L211.364 116.652L218.981 106.763L218.634 106.589Z",
    fill: "#C38B2C"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path356 || (_path356 = /*#__PURE__*/React.createElement("path", {
    d: "M219.612 106.949L211.997 116.839L212.344 117.012L219.959 107.123L219.612 106.949Z",
    fill: "#C38B2C"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path357 || (_path357 = /*#__PURE__*/React.createElement("path", {
    d: "M220.572 107.31L212.955 117.198L213.302 117.372L220.919 107.483L220.572 107.31Z",
    fill: "#C38B2C"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path358 || (_path358 = /*#__PURE__*/React.createElement("path", {
    d: "M221.528 107.659L213.911 117.547L214.258 117.721L221.875 107.832L221.528 107.659Z",
    fill: "#C38B2C"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path359 || (_path359 = /*#__PURE__*/React.createElement("path", {
    d: "M222.48 107.997L214.863 117.886L215.21 118.059L222.827 108.171L222.48 107.997Z",
    fill: "#C38B2C"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path360 || (_path360 = /*#__PURE__*/React.createElement("path", {
    d: "M223.416 108.328L215.799 118.216L216.146 118.39L223.763 108.501L223.416 108.328Z",
    fill: "#C38B2C"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path361 || (_path361 = /*#__PURE__*/React.createElement("path", {
    d: "M224.37 108.674L216.75 118.562L217.098 118.736L224.717 108.848L224.37 108.674Z",
    fill: "#C38B2C"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path362 || (_path362 = /*#__PURE__*/React.createElement("path", {
    d: "M225.263 108.969L217.645 118.858L217.993 119.031L225.61 109.143L225.263 108.969Z",
    fill: "#C38B2C"
  }))))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    },
    opacity: 0.23
  }, _path363 || (_path363 = /*#__PURE__*/React.createElement("path", {
    d: "M198.52 90.7362C194.095 88.7676 189.878 87.1964 186.209 86.1221L176.873 98.2317C179.695 100.405 183.31 102.753 187.465 105.069L198.512 90.7362H198.52Z",
    fill: "#FFFAEF"
  }))), _path364 || (_path364 = /*#__PURE__*/React.createElement("path", {
    d: "M225.44 111.41C223.181 114.341 209.752 110.926 195.452 103.778C181.152 96.6301 171.392 88.4514 173.651 85.5202C175.909 82.5891 189.339 86.0046 203.639 93.1524C217.939 100.3 227.699 108.479 225.44 111.41Z",
    fill: "url(#paint21_linear_13193_55427)"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    },
    opacity: 0.33
  }, _path365 || (_path365 = /*#__PURE__*/React.createElement("path", {
    d: "M192.631 101.027C195.706 101.263 198.782 101.536 201.866 101.728C204.934 101.921 208.002 102.07 211.071 102.213C213.769 102.337 216.459 102.449 219.157 102.579C216.829 100.791 213.969 98.8842 210.716 96.9777C209.105 96.8473 207.486 96.7231 205.875 96.5927C201.588 96.2511 197.302 95.8971 193.024 95.4997C188.768 95.1023 184.521 94.6489 180.257 94.2515C180.096 94.2329 179.926 94.2204 179.764 94.208C182.485 96.3194 185.962 98.5923 189.963 100.853C190.857 100.909 191.744 100.965 192.638 101.033L192.631 101.027Z",
    fill: "#FFFAEF"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask11_13193_55427",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 179,
    y: 87,
    width: 42,
    height: 22
  }, _path366 || (_path366 = /*#__PURE__*/React.createElement("path", {
    d: "M220.001 108.091C221.577 106.045 213.836 99.8787 202.712 94.3181C191.587 88.7574 181.292 85.9081 179.716 87.9539C178.14 89.9998 185.881 96.166 197.005 101.727C208.13 107.287 218.425 110.137 220.001 108.091Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask11_13193_55427)"
  }, _path367 || (_path367 = /*#__PURE__*/React.createElement("path", {
    d: "M220.001 108.091C221.577 106.045 213.836 99.8792 202.712 94.3185C191.587 88.7579 181.292 85.9086 179.716 87.9544C178.14 90.0003 185.881 96.1665 197.005 101.727C208.13 107.288 218.425 110.137 220.001 108.091Z",
    fill: "url(#paint22_linear_13193_55427)"
  })), _path368 || (_path368 = /*#__PURE__*/React.createElement("path", {
    d: "M219.148 109.856C220.724 107.81 212.983 101.644 201.859 96.0832C190.734 90.5225 180.438 87.6732 178.863 89.719C177.287 91.7649 185.027 97.9311 196.152 103.492C207.276 109.052 217.572 111.902 219.148 109.856Z",
    fill: "url(#paint23_linear_13193_55427)"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    },
    opacity: 0.11
  }, _path369 || (_path369 = /*#__PURE__*/React.createElement("path", {
    d: "M181.729 94.1772L208.472 96.8973L217.446 102.642L192.514 101.213L181.729 94.1772Z",
    fill: "#FFFAEF"
  })))), _path370 || (_path370 = /*#__PURE__*/React.createElement("path", {
    d: "M223.559 112.336C222.333 112.603 221.046 112.547 219.797 112.447L218.857 112.354L217.924 112.218C217.299 112.137 216.69 112.007 216.074 111.901C213.63 111.404 211.248 110.733 208.92 109.97C204.256 108.442 199.808 106.535 195.521 104.43C193.386 103.362 191.289 102.251 189.246 101.071C187.219 99.872 185.222 98.6425 183.326 97.3135C181.421 95.9907 179.594 94.5935 177.914 93.0782C177.081 92.3206 176.287 91.5257 175.563 90.6936C174.846 89.8614 174.183 88.9858 173.759 88.0356C174.923 89.8241 176.619 91.3146 178.384 92.7118C180.149 94.1153 182.046 95.4132 183.981 96.6614C187.874 99.1455 191.975 101.418 196.207 103.511C200.432 105.61 204.803 107.535 209.321 109.2C211.579 110.019 213.877 110.789 216.243 111.392C216.837 111.541 217.423 111.702 218.024 111.82L218.926 112.007L219.836 112.156C221.054 112.317 222.303 112.472 223.544 112.317L223.559 112.336Z",
    fill: "#FEDE9A"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_13193_55427",
    x: 15.37,
    y: 59.343,
    width: 105.703,
    height: 77.5934,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 2.83,
    dy: 14.17
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 11.34
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.317647 0 0 0 0 0.356863 0 0 0 0 0.309804 0 0 0 0.6 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_13193_55427"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_13193_55427",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_d_13193_55427",
    x: 104.192,
    y: 0.462168,
    width: 100.118,
    height: 84.3532,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 2.83,
    dy: 14.17
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 11.34
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.317647 0 0 0 0 0.356863 0 0 0 0 0.309804 0 0 0 0.6 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_13193_55427"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_13193_55427",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_d_13193_55427",
    x: 89.6311,
    y: 201.753,
    width: 104.82,
    height: 78.9288,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 2.83,
    dy: 14.17
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 11.34
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.317647 0 0 0 0 0.356863 0 0 0 0 0.309804 0 0 0 0.6 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_13193_55427"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_13193_55427",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter3_d_13193_55427",
    x: 183.762,
    y: 226.296,
    width: 104.97,
    height: 78.6691,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 2.83,
    dy: 14.17
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 11.34
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.317647 0 0 0 0 0.356863 0 0 0 0 0.309804 0 0 0 0.6 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_13193_55427"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_13193_55427",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter4_d_13193_55427",
    x: 0.749548,
    y: 251.071,
    width: 102.274,
    height: 79.7741,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 2.83,
    dy: 14.17
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 11.34
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.317647 0 0 0 0 0.356863 0 0 0 0 0.309804 0 0 0 0.6 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_13193_55427"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_13193_55427",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter5_d_13193_55427",
    x: 150.454,
    y: 75.9573,
    width: 100.821,
    height: 77.2736,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 2.83,
    dy: 14.17
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 11.34
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.317647 0 0 0 0 0.356863 0 0 0 0 0.309804 0 0 0 0.6 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_13193_55427"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_13193_55427",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_13193_55427",
    x1: 38.1121,
    y1: 71.7575,
    x2: 89.6783,
    y2: 107.27,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#805A1D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.06,
    stopColor: "#9F7124"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.12,
    stopColor: "#C38B2C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.21,
    stopColor: "#E2A132"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.22,
    stopColor: "#E8A534"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.55,
    stopColor: "#E8A534"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#C88E2D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopColor: "#C38B2C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.89,
    stopColor: "#A37324"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99,
    stopColor: "#805A1D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_13193_55427",
    x1: 73.2216,
    y1: 72.5832,
    x2: 62.2871,
    y2: 97.0511,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFFAE5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.32,
    stopColor: "#F1DA7F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.55,
    stopColor: "#E8C334"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.81,
    stopColor: "#D9B629"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.88,
    stopColor: "#B89A24"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99,
    stopColor: "#806A1D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_13193_55427",
    x1: 75.8019,
    y1: 68.8521,
    x2: 67.4358,
    y2: 87.5725,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#C38B2C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.49,
    stopColor: "#A37324"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.77,
    stopColor: "#805A1D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.89,
    stopColor: "#9F7124"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C38B2C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_13193_55427",
    x1: 71.8794,
    y1: 75.3153,
    x2: 63.5134,
    y2: 94.0357,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#FFBA3A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.52,
    stopColor: "#DFA132"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.77,
    stopColor: "#C48D2D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#E3A534"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFBA3A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_13193_55427",
    x1: 127.552,
    y1: 44.6613,
    x2: 169.081,
    y2: 1.24984,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#805A1D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.06,
    stopColor: "#9F7124"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.12,
    stopColor: "#C38B2C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.21,
    stopColor: "#E2A132"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.22,
    stopColor: "#E8A534"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.55,
    stopColor: "#E8A534"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#C88E2D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopColor: "#C38B2C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.89,
    stopColor: "#A37324"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99,
    stopColor: "#805A1D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_13193_55427",
    x1: 141.023,
    y1: 18.5303,
    x2: 156.613,
    y2: 41.5128,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFFAE5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.32,
    stopColor: "#F1DA7F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.55,
    stopColor: "#E8C334"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.81,
    stopColor: "#D9B629"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.88,
    stopColor: "#B89A24"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99,
    stopColor: "#806A1D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_13193_55427",
    x1: 137.615,
    y1: 15.2688,
    x2: 149.538,
    y2: 32.8459,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#C38B2C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.49,
    stopColor: "#A37324"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.77,
    stopColor: "#805A1D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.89,
    stopColor: "#9F7124"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C38B2C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_13193_55427",
    x1: 143.721,
    y1: 20.5201,
    x2: 155.644,
    y2: 38.0973,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#FFBA3A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.52,
    stopColor: "#DFA132"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.77,
    stopColor: "#C48D2D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#E3A534"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFBA3A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_13193_55427",
    x1: 112.554,
    y1: 240.043,
    x2: 162.288,
    y2: 202.786,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#805A1D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.06,
    stopColor: "#9F7124"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.12,
    stopColor: "#C38B2C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.21,
    stopColor: "#E2A132"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.22,
    stopColor: "#E8A534"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.55,
    stopColor: "#E8A534"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#C88E2D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopColor: "#C38B2C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.89,
    stopColor: "#A37324"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99,
    stopColor: "#805A1D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_13193_55427",
    x1: 130.941,
    y1: 215.948,
    x2: 142.73,
    y2: 240.198,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFFAE5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.32,
    stopColor: "#F1DA7F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.55,
    stopColor: "#E8C334"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.81,
    stopColor: "#D9B629"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.88,
    stopColor: "#B89A24"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99,
    stopColor: "#806A1D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_13193_55427",
    x1: 128.203,
    y1: 212.3,
    x2: 137.219,
    y2: 230.847,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#C38B2C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.49,
    stopColor: "#A37324"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.77,
    stopColor: "#805A1D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.89,
    stopColor: "#9F7124"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C38B2C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_13193_55427",
    x1: 133.213,
    y1: 218.249,
    x2: 142.229,
    y2: 236.795,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#FFBA3A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.52,
    stopColor: "#DFA132"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.77,
    stopColor: "#C48D2D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#E3A534"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFBA3A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear_13193_55427",
    x1: 206.593,
    y1: 238.609,
    x2: 256.665,
    y2: 275.546,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#805A1D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.06,
    stopColor: "#9F7124"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.12,
    stopColor: "#C38B2C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.21,
    stopColor: "#E2A132"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.22,
    stopColor: "#E8A534"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.55,
    stopColor: "#E8A534"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#C88E2D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopColor: "#C38B2C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.89,
    stopColor: "#A37324"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99,
    stopColor: "#805A1D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint13_linear_13193_55427",
    x1: 241.652,
    y1: 240.28,
    x2: 230.023,
    y2: 264.573,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFFAE5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.32,
    stopColor: "#F1DA7F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.55,
    stopColor: "#E8C334"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.81,
    stopColor: "#D9B629"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.88,
    stopColor: "#B89A24"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99,
    stopColor: "#806A1D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint14_linear_13193_55427",
    x1: 244.36,
    y1: 236.609,
    x2: 235.463,
    y2: 255.195,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#C38B2C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.49,
    stopColor: "#A37324"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.77,
    stopColor: "#805A1D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.89,
    stopColor: "#9F7124"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C38B2C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint15_linear_13193_55427",
    x1: 240.201,
    y1: 242.976,
    x2: 231.308,
    y2: 261.555,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#FFBA3A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.52,
    stopColor: "#DFA132"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.77,
    stopColor: "#C48D2D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#E3A534"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFBA3A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint16_linear_13193_55427",
    x1: 23.9407,
    y1: 263.97,
    x2: 70.0108,
    y2: 299.543,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#805A1D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.06,
    stopColor: "#9F7124"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.12,
    stopColor: "#C38B2C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.21,
    stopColor: "#E2A132"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.22,
    stopColor: "#E8A534"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.55,
    stopColor: "#E8A534"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#C88E2D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopColor: "#C38B2C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.89,
    stopColor: "#A37324"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99,
    stopColor: "#805A1D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint17_linear_13193_55427",
    x1: 58.167,
    y1: 264.827,
    x2: 44.7928,
    y2: 291.922,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFFAE5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.32,
    stopColor: "#F1DA7F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.55,
    stopColor: "#E8C334"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.81,
    stopColor: "#D9B629"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.88,
    stopColor: "#B89A24"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99,
    stopColor: "#806A1D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint18_linear_13193_55427",
    x1: 61.22,
    y1: 260.269,
    x2: 50.1024,
    y2: 281.419,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#C38B2C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.49,
    stopColor: "#A37324"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.77,
    stopColor: "#805A1D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.89,
    stopColor: "#9F7124"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C38B2C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint19_linear_13193_55427",
    x1: 56.4069,
    y1: 267.25,
    x2: 45.2892,
    y2: 288.4,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#FFBA3A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.52,
    stopColor: "#DFA132"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.77,
    stopColor: "#C48D2D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#E3A534"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFBA3A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint20_linear_13193_55427",
    x1: 173.159,
    y1: 88.0114,
    x2: 219.213,
    y2: 123.514,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#805A1D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.06,
    stopColor: "#9F7124"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.12,
    stopColor: "#C38B2C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.21,
    stopColor: "#E2A132"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.22,
    stopColor: "#E8A534"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.55,
    stopColor: "#E8A534"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#C88E2D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopColor: "#C38B2C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.89,
    stopColor: "#A37324"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99,
    stopColor: "#805A1D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint21_linear_13193_55427",
    x1: 206.019,
    y1: 90.0931,
    x2: 194.674,
    y2: 112.773,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFFAE5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.32,
    stopColor: "#F1DA7F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.55,
    stopColor: "#E8C334"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.81,
    stopColor: "#D9B629"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.88,
    stopColor: "#B89A24"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99,
    stopColor: "#806A1D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint22_linear_13193_55427",
    x1: 208.605,
    y1: 86.6445,
    x2: 199.933,
    y2: 103.987,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#C38B2C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.49,
    stopColor: "#A37324"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.77,
    stopColor: "#805A1D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.89,
    stopColor: "#9F7124"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C38B2C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint23_linear_13193_55427",
    x1: 204.56,
    y1: 92.5507,
    x2: 195.885,
    y2: 109.899,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#FFBA3A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.52,
    stopColor: "#DFA132"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.77,
    stopColor: "#C48D2D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#E3A534"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFBA3A"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCoinsDrop);
export default __webpack_public_path__ + "static/media/coins-drop.92003099.svg";
export { ForwardRef as ReactComponent };